import type { LocaleResources } from '../types';

export const is = {
  common: {
    matrixEditLabel: 'Breyta birtingarheiti',
    matrixRestoreLabel: 'Endurheimta vöruheiti úr vöruskrá',
    matrixPersonalLabelHint:
      'Aðeins fyrir þinn aðgang, sameiginlegt fyrir sölu og sendingar. Breytir ekki vöruskrá.',
    matrixLabelSaveFailed: 'Heiti var ekki vistað. Endurnýjaðu gögnin og reyndu aftur.',
    matrixDisplayLabel: 'Þitt vöruheiti',
    matrixLabelLimit: '1 til 80 stafir, venjulegur texti.',
    matrixLabelPreview: 'Forskoðun',
    appName: 'KJÖTKOMPANIÐ Rekstur',
    loading: 'Hleð…',
    readFromImage: 'Lesa úr mynd',
    importOrderFile: 'Flytja inn pöntunarskrá',
    fileImportReview: 'Yfirferð skráarinnflutnings',
    pdfTextUnavailable: 'Þessi PDF inniheldur ekki texta fyrir sjálfvirkan innflutning.',
    storeMatches: 'VERSLUN STEMMIR',
    possibleStoreMismatch: 'MÖGULEGT MISRÆMI VERSLUNAR: fann {{store}}.',
    selectedStore: 'Valin verslun: {{store}}',
    imageReview: 'Yfirferð myndlestrar',
    imageReadFailed: 'Ekki tókst að lesa myndina. Þú getur skráð pöntunina handvirkt.',
    fileImportFailed: 'Ekki tókst að lesa skrána. Þú getur skráð pöntunina handvirkt.',
    reviewRequired: 'Þarf yfirferð',
    unit: 'Eining',
    addToDraft: 'Bæta við pöntunardrög',
    sources: 'Heimildir',
    save: 'Vista',
    cancel: 'Hætta við',
    language: 'Tungumál',
    appearance: 'Útlit',
    appearanceLight: 'Ljóst',
    appearanceDark: 'Dökkt',
    appearanceSystem: 'Kerfi',
    signedInAs: 'Skráð inn sem {{name}}',
    foundationReady: 'Grunnkerfið er tilbúið',
    foundationDescription: 'Rekstrareiningar verða afhentar í síðari samþykktum áföngum.',
    unavailable: 'Ekki tiltækt enn',
    quantityUnit: { PIECE: 'stk.', KG: 'kg' },
    errors: {
      MASTER_DATA_LOCK_TIMEOUT:
        'Önnur aðgerð er að uppfæra grunngögn. Endurnýjaðu gögnin og reyndu aftur.',
      technicalId: 'Tæknilegt auðkenni: {{id}}',
    },
    incompleteQuantity: 'Vantar suma skýrsludaga; gildið nær aðeins yfir staðfesta daga.',
    fractionalPieceQuantity: 'Brot af stykkjafjölda þarf að yfirfara.',
  },
  auth: {
    title: 'Örugg innskráning',
    email: 'Netfang',
    code: 'Eingöngukóði',
    requestCode: 'Senda kóða',
    verifyCode: 'Staðfesta og skrá inn',
    signOut: 'Skrá út',
    sent: 'Ef reikningurinn er virkur hefur eingöngukóði verið sendur.',
    codeHint: 'Kóðinn rennur út eftir um það bil 10 mínútur.',
    invalid: 'Ekki tókst að staðfesta kóðann.',
    sessionExpired: 'Setan er útrunnin. Skráðu þig inn aftur.',
  },
  navigation: {
    open: 'Opna leiðsögn',
    close: 'Loka leiðsögn',
    overview: 'Grunngögn',
    products: 'Vörur',
    abpCatalog: 'ABP vörulisti',
    materials: 'Efni og hráefni',
    stores: 'Verslanir',
    networks: 'Verslanakeðjur',
    users: 'Notendur',
    settings: 'Stillingar',
    stock: 'Birgðastaða',
    sales: 'Sala',
    shipments: 'Sendingar',
    warehouse: 'Vöruhús',
    production: 'Framleiðsla',
    forecast: 'Spá',
    costing: 'Kostnaðarreiknir',
    productCostLibrary: 'Framleiðslukostnaður vara',
    costInputBase: 'Kostnaðargrunnur',
    profitability: 'Arðsemi',
    orders: 'Pantanir',
    analytics: 'Greining',
    dashboard: 'Yfirlit',
    operations: 'Rekstur',
    importCenter: 'Innflutningsmiðstöð',
    overviewGroup: 'YFIRLIT',
    salesGroup: 'SALA',
    operationsGroup: 'REKSTUR',
    economicsGroup: 'HAGFRÆÐI',
    masterDataGroup: 'GRUNNGÖGN',
    collapseSidebar: 'Fella saman hliðarstiku',
    expandSidebar: 'Stækka hliðarstiku',
  },
  users: {
    title: 'Notendur og aðgangur',
    role: 'Hlutverk',
    status: 'Staða',
    active: 'Virkur',
    deactivated: 'Óvirkur',
    managedByAdmin: 'Notendastjórnun er varin með heimildum á bakenda.',
    createUser: 'Bæta við notanda',
    create: 'Stofna notanda',
    cancel: 'Hætta við',
    close: 'Loka',
    email: 'Netfang',
    displayName: 'Birtingarnafn',
    access: 'Aðgangsfrávik',
    actions: 'Aðgerðir',
    manage: 'Stjórna',
    manageUser: 'Stjórna {{email}}',
    overrideCount_one: '{{count}} frávik',
    overrideCount_other: '{{count}} frávik',
    actionFailed: 'Ekki tókst að vista aðgangsbreytinguna. Reyndu aftur.',
    activate: 'Virkja',
    deactivate: 'Gera óvirkan',
    confirmActivate: 'Virkja þennan notanda?',
    confirmDeactivate: 'Gera notandann óvirkan og afturkalla virkar setur?',
    revokeSessions: 'Afturkalla allar setur',
    effectiveAccess: 'Virkur aðgangur',
    effectiveAccessDescription: 'Sjálfgefnar heimildir hlutverks og sértæk frávik notanda.',
    permission: 'Heimild',
    roleDefault: 'Sjálfgefið hlutverk',
    override: 'Frávik',
    effective: 'Virkt',
    inherit: 'Erfa hlutverk',
    allow: 'Leyfa',
    deny: 'Banna',
    roles: {
      ADMIN: 'Stjórnandi',
      ELDHUS_MANAGER: 'Eldhússtjóri',
      SALESMAN: 'Sölumaður',
      VIEWER: 'Áhorfandi',
    },
    roleDescriptions: {
      ADMIN: 'Fullur rekstraraðgangur; hlutverk og staða eru varin.',
      ELDHUS_MANAGER: 'Rekstrarstjóri með aðgang að vöruhúsi og grunngögnum.',
      SALESMAN: 'Aðgangur að sölu og viðskiptalegum rekstri.',
      VIEWER: 'Lesaðgangur að rekstrargögnum.',
    },
  },
  settings: {
    title: 'Persónulegar stillingar',
    languageTitle: 'Tungumál viðmóts',
    languageDescription: 'Valið er vistað á öruggan hátt með notandareikningnum.',
    appearanceDescription: 'Veldu ljóst, dökkt eða útlit sem fylgir stýrikerfinu.',
    saved: 'Tungumálaval vistað.',
  },
  validation: {
    required: 'Þessi reitur er nauðsynlegur.',
    invalidEmail: 'Sláðu inn gilt netfang.',
    sixDigitCode: 'Sláðu inn sex stafa kóðann.',
    generic: 'Athugaðu innsláttinn.',
  },
  master: {
    resultCount: '{{count}} niðurstöður',
    previous: 'Fyrri',
    next: 'Næsta',
    viewSaved: 'Sýn vistuð',
    saveView: 'Vista sýn',
    search: 'Leita',
    status: 'Staða',
    showAll: 'Sýna allt',
    sort: 'Röðun',
    updated: 'Uppfært',
    notConfigured: 'Ekki skilgreint',
    ready: 'Grunngögn eru tilbúin',
    readyDescription:
      'Stjórnaðu samþykktum vöru-, verslunar- og viðskiptagögnum sem síðari vinnsluþrep nota.',
    productsCard: 'Vörur',
    productsCardDescription: 'Vöruskrá, einingar, vörpun, dreifing og gildissaga viðskiptagagna.',
    storesCard: 'Verslanir',
    storesCardDescription:
      'Verslanakeðjur, staðir, tengiliðir, athugasemdir, vörpun og virkni vara.',
  },
  products: {
    title: 'Vörur',
    description: 'Samþykkt vöruskrá og tímagild viðskiptastilling.',
    create: 'Stofna vöru',
    sku: 'Vörunúmer',
    officialName: 'Opinbert heiti',
    displayAlias: 'Stutt heiti',
    category: 'Vöruflokkur',
    salesUnit: 'Sölueining',
    financialUnit: 'Fjárhagseining',
    operationalArea: 'Rekstrarsvæði',
    netWeightKg: 'Nettóþyngd (kg)',
    piecesPerTray: 'Stykki á bakka',
    name: 'Heiti',
    units: 'Einingar',
    distribution: 'Dreifing eftir keðju',
    salePriceNet: 'Söluverð NETTÓ',
    productionCostNet: 'Framleiðslukostnaður NETTÓ',
    back: 'Til baka í vörur',
    general: 'Almennt',
    unitsSummary: 'Sala: {{sales}} · Fjárhagur: {{financial}} · Svæði: {{area}}',
    conversions: 'Einingaumbreytingar vöru',
    fromUnit: 'Frá einingu',
    toUnit: 'Í einingu',
    factor: 'Stuðull',
    effectiveFrom: 'Gildir frá',
    add: 'Bæta við',
    network: 'Verslanakeðja',
    mode: 'Dreifingarháttur',
    directStore: 'Bein endurbirgðing verslana',
    centralSellThrough: 'Sala í gegnum miðlægt vöruhús',
    addVersion: 'Bæta við útgáfu',
    centralExplanation:
      'Miðlæg sala felur ekki í sér birgðir verslana, GOAL, endurpöntun eða birgðaviðvaranir. Skráning upphafsstöðu vöruflæðis bíður birgðaþreps.',
    storeActivation: 'Virkni eftir verslun',
    store: 'Verslun',
    stores: 'Verslanir',
    salePriceHistory: 'Saga almenns söluverðs',
    netPrice: 'Nettó einingarverð í ISK',
    costHistory: 'Saga framleiðslukostnaðar',
    netCost: 'Nettó einingarkostnaður í ISK',
    planningFoundation: 'Grunnur GOAL, endurpöntunar og viðvörunarmarka',
    notCalculated:
      'Engin reiknuð gildi eru til á þessu þrepi. Aðeins skýrar handvirkar útgáfur eru vistaðar fyrir beina dreifingu.',
    manualValue: 'Handvirkt gildi',
    setGoal: 'Stilla GOAL',
    setReorder: 'Stilla handvirka endurpöntun',
    setThreshold: 'Stilla handvirk mörk',
    aliases: 'Heiti úr upprunakerfum',
    source: 'Uppruni',
    sourceSku: 'Vörunúmer uppruna',
    sourceName: 'Heiti uppruna',
    provenance: 'Uppruni vörpunar',
    audit: 'Breytingasaga',
    categoryCode: 'Flokkakóði',
    categoryName: 'Heiti vöruflokks',
    manageCategories: 'Stjórna vöruflokkum',
    createCategory: 'Stofna vöruflokk',
    safetyBuffer: 'Öryggisstuðull',
    activate: 'Virkja',
    deactivate: 'Gera óvirkt',
    shipmentSourceRoute: 'Uppruni sendingar',
    noShipmentSourceRoute: 'Engin úthlutun',
    routeReason: 'Ástæða leiðarbreytingar',
    saveShipmentSourceRoute: 'Vista upprunaleið',
    shipmentSourceMatch: 'Samsvörun SKU úr sendingu',
    shipmentSourceMatchHelp:
      'Handvirk samsvörun stofnar opinbert samheiti fyrir komandi sendingainnflutning.',
    matchShipmentSource: 'Samsvara við núverandi vöru',
    shipmentProductIntakeCount: 'Ný sendingar-SKU sem þarfnast yfirferðar: {{count}}',
    shipmentProductIntakeTitle: 'Nýjar vörur úr sendingum',
    shipmentProductIntakeReview: 'Þarfnast yfirferðar',
    shipmentProductIntakeSku: 'Uppruna-SKU',
    shipmentProductIntakeName: 'Upprunavara',
    shipmentProductIntakeStatus: 'Staða',
    shipmentProductIntakeSuggestion: 'Tillaga að samsvörun / uppruna',
    shipmentProductIntakeStatus_NEW: 'Nýtt',
    shipmentProductIntakeStatus_MATCH_REVIEW_REQUIRED: 'Samsvörun þarfnast yfirferðar',
    shipmentProductIntakeStatus_UNASSIGNED: 'Þarfnast ákvörðunar um uppruna',
    shipmentProductIntakeStatus_AUTO_CREATED: 'Búið til sjálfvirkt',
    shipmentProductIntakeStatus_RESOLVED: 'Leyst',
  },
  stores: {
    title: 'Verslanir',
    description: 'Samþykktar verslanir, tengiliðir, vörpun og virkni vara.',
    create: 'Stofna verslun',
    network: 'Verslanakeðja',
    name: 'Heiti verslunar',
    shortName: 'Stutt heiti',
    noPrimaryContact: 'Enginn aðaltengiliður',
    activeProductsCount: '{{count}} virkar vörur',
    primaryContact: 'Aðaltengiliður',
    activeProducts: 'Virkar vörur',
    aliases: 'Heiti úr upprunakerfum',
    back: 'Til baka í verslanir',
    general: 'Almennt',
    contacts: 'Tengiliðir',
    primary: 'Aðal',
    deactivate: 'Gera óvirkt',
    activate: 'Virkja',
    contactName: 'Nafn tengiliðar',
    roleTitle: 'Hlutverk / starfsheiti',
    phone: 'Sími',
    email: 'Netfang',
    setPrimary: 'Gera að aðaltengilið',
    addContact: 'Bæta við tengilið',
    feedback: 'Rekstrarathugasemdir',
    feedbackText: 'Athugasemd',
    optionalProduct: 'Valfrjáls vara',
    categoryTag: 'Flokkur / merki',
    addFeedback: 'Bæta við athugasemd',
    product: 'Vara',
    source: 'Uppruni',
    rawAlias: 'Upprunalegt heiti / kóði',
    provenance: 'Uppruni vörpunar',
    addAlias: 'Bæta við heiti',
    extendHistory: 'Lengja sögu',
    audit: 'Breytingasaga',
    editContact: 'Breyta',
    updateContact: 'Uppfæra tengilið',
  },
  networks: {
    title: 'Verslanakeðjur',
    description: 'Samþykktar verslanakeðjur sem allir notendur deila.',
    create: 'Stofna verslanakeðju',
    code: 'Kóði',
    name: 'Samþykkt heiti',
    shortName: 'Stutt heiti',
    edit: 'Breyta verslanakeðju',
  },
  inventory: {
    title: 'Birgðir',
    warehouseTitle: 'Vöruhúsabirgðir',
    description: 'Endurskoðaðar raunbirgðir með skýru óþekktu ástandi og endurbyggjanlegri sögu.',
    positions: 'Birgðastaða',
    openingStock: 'Upphafsbirgðir',
    physicalCount: 'Rauntalning',
    physicalCountHelp: 'Bókar óbreytanlegt talningarmagn og mismun frá athuguðu magni í færslubók.',
    warehouseCorrection: 'Stýrð leiðrétting',
    warehouseCorrectionHelp:
      'Bókar sértæka, endurskoðanlega vöruhúsaleiðréttingu; birgðastaða er aldrei breytt beint.',
    countHistory: 'Saga talninga og mismunar',
    warehouseTransfer: 'Flutningur milli vöruhúsa',
    warehouseTransferHelp:
      'Flutningur er óbreytanleg hreyfing milli tveggja áður frumstilltra vöruhúsastaða.',
    transferDestination: 'Móttökuvöruhús',
    transferQuantity: 'Magn til flutnings',
    submitTransfer: 'Bóka flutning',
    transferPosted: 'Flutningur bókaður. Uppruni: {{from}}, áfangastaður: {{to}}.',
    history: 'Birgðasaga',
    pipeline: 'Birgðir í dreifikerfi',
    locationKind: 'Tegund staðsetningar',
    store: 'Verslun',
    warehouse: 'Vöruhús',
    location: 'Staðsetning',
    allLocations: 'Allar staðsetningar',
    product: 'Vara',
    unitFilter: 'Eining',
    allUnits: 'Allar einingar',
    current: 'Núverandi magn',
    actual: 'Raunmagn við talningu',
    quality: 'Gæði gagna',
    stockStateLabel: 'Birgðastaða',
    revision: 'Útgáfa',
    unknown: 'ÓÞEKKT',
    enterActual: 'Skrá talningu',
    physicalEntry: 'Talning og upphafsbirgðir',
    businessDate: 'Viðskiptadagur',
    reason: 'Ástæða',
    addOpeningLine: 'Bæta við drög',
    confirmOpening: 'Staðfesta upphafsbirgðir',
    submitCorrection: 'Senda leiðréttingu',
    submitPhysicalCount: 'Staðfesta rauntalningu',
    warehouseCountPosted: '{{count}} lína/línur rauntalningar bókaðar.',
    openingDraft: 'Drög að upphafsbirgðum',
    date: 'Dagsetning',
    movement: 'Hreyfing',
    result: 'Niðurstaða',
    variance: 'Mismunur',
    varianceHelp: 'Raunmagn mínus athugað magn í færslubók.',
    calculated: 'Reiknað magn',
    lastMovement: 'Síðasta hreyfing',
    lastPhysicalCount: 'Síðasta talning',
    actions: 'Aðgerðir',
    countAction: 'Telja',
    correctAction: 'Leiðrétta',
    viewMovements: 'Hreyfingar',
    evidence: 'Sönnunargagn',
    pieceUnit: 'stk.',
    kilogramUnit: 'kg',
    estimatedPipeline: 'ÁÆTLAÐAR BIRGÐIR Í DREIFIKERFI',
    pipelineExplanation:
      'Þetta er staðfest grunnstaða, ekki lifandi útreikningur á verslunarbirgðum.',
    pipelineRows: '{{count}} grunnstöður í dreifikerfi',
    correctionPosted: 'Leiðrétting skráð. Breyting í færslubók: {{delta}}.',
    openingConfirmed: '{{count}} hreyfingar upphafsbirgða staðfestar.',
    stockChanged:
      'Birgðir breyttust meðan eyðublaðið var opið. Yfirfarðu nýja stöðu og sendu aftur.',
    operationFailed: 'Ekki tókst að ljúka birgðaaðgerðinni.',
    stockWorkspaceTitle: 'Birgðastaða',
    stockWorkspaceDescription: 'Lesaðgangur að rekstrarbirgðum úr óbreytanlegri birgðabók.',
    asOf: 'Staða þann',
    productSearch: 'Leita að vöru',
    matrixOrientation: 'Stefna fylkis',
    storesByProducts: 'Verslanir × vörur',
    productsByStores: 'Vörur × verslanir',
    resetOrder: 'Endurstilla röð',
    storesCount: '{{count}} verslanir',
    productsCount: '{{count}} vörur',
    knownCells: '{{count}} þekktar',
    incompleteCells: '{{count}} ófullnægjandi',
    notInitializedCells: '{{count}} ófrumstilltar',
    notManagedCells: '{{count}} miðstýrðar',
    lowCells: '{{count}} lágar',
    workspaceLoadFailed: 'Ekki tókst að hlaða birgðastöðu.',
    stockMatrix: 'Birgðafylki',
    rowLabel: 'Verslun / vara',
    notManaged: 'MIÐLÆGT',
    notInitialized: 'ÓÞEKKT',
    notApplicable: 'Vara er ekki virk fyrir þessa verslun',
    stockDrillDown: 'Birgðaupplýsingar',
    goal: 'MARKMIÐ',
    difference: 'Mismunur',
    reorder: 'Endurpöntun',
    provisional: 'bráðabirgða',
    distributionMode: 'Dreifingarmáti',
    ledgerExplanation: 'Skýring birgðabókar',
    stockState: {
      KNOWN: 'ÞEKKT',
      NOT_INITIALIZED: 'EKKI FRUMSTILLT',
      INCOMPLETE_DATA: 'ÓFULLNÆGJANDI GÖGN',
      NOT_MANAGED: 'MIÐSTÝRT',
      NOT_APPLICABLE: 'EKKI VIRK FYRIR ÞESSA VERSLUN',
    },
  },
  sales: {
    title: 'Söluvinnusvæði',
    description: 'Skrifvarinn rekstrarskjár fyrir staðfestar daglegar söluskýrslur.',
    datePreset: 'Dagsetningabil',
    from: 'Frá',
    to: 'Til',
    network: 'Keðja',
    allNetworks: 'Allar keðjur',
    store: 'Verslun',
    allStores: 'Allar verslanir',
    productSearch: 'Leita að vöru',
    product: 'Vara',
    allProducts: 'Allar vörur',
    orientation: 'Uppsetning fylkis',
    storesByProducts: 'Verslanir × vörur',
    productsByStores: 'Vörur × verslanir',
    knownSales: 'Þekkt sala',
    storesCount: '{{count}} verslanir',
    productsCount: '{{count}} virkar vörur',
    reportDays: '{{confirmed}} / {{expected}} staðfestir skýrsludagar',
    matrix: 'Sölufylki',
    rowLabel: 'Verslun / vara',
    drillDown: 'Upplýsingar um reit',
    date: 'Dagsetning',
    quantity: 'Magn',
    coverageLabel: 'Þekja',
    known: 'Þekkt',
    knownZero: 'Þekkt núll',
    unknown: 'ÓÞEKKT',
    unknownCell: 'Gögn vantar ⚠',
    sum: 'SAMTALS',
    totalDrillDownHint: 'Sjá hvar og hvenær var selt',
    openTotalDrillDown: 'Sýna samtölu fyrir {{column}}',
    productSalesInPeriod: 'VÖRUSALA Á TÍMABILI',
    storeSalesInPeriod: 'VERSLUNARSALA Á TÍMABILI',
    totalDetails: 'UPPLÝSINGAR',
    byStore: 'EFTIR VERSLUN',
    byDay: 'EFTIR DEGI',
    showZeros: 'Sýna núll',
    hideZeros: 'Fela núll',
    share: 'Hlutfall',
    storesWithSales: 'Verslanir með sölu',
    incompleteTotals: 'ÓFULLNÆGJANDI GÖGN',
    incompleteTotalsDescription: 'Röðun og samtala innihalda aðeins þekkt staðfest magn.',
    loadFailed: 'Ekki tókst að hlaða sölusvæði.',
    coverage: { COMPLETE: 'FULLKOMIÐ', INCOMPLETE_DATA: 'ÓFULLNÆGJANDI GÖGN' },
    coverageDetailOpen: 'Opna stöðu söluþekju',
    coverageDetailTitle: 'Staða gagnaþekju',
    coverageDetailGoToImportCenter: 'Fara í innflutningsmiðstöð',
    coverageDetailGroup: {
      missing: 'VANTAR',
      ready: 'TIL STAÐFESTINGAR',
      needsFixing: 'ÞARF LAGFÆRINGU',
    },
    coverageDetailState: {
      NOT_UPLOADED: 'Engin skýrsla',
      PROCESSING: 'Í vinnslu',
      PREVIEW_READY: 'Tilbúið til staðfestingar',
      BLOCKED: 'Lokað',
      CONFLICT: 'Árekstur',
      FAILED: 'Innflutningur mistókst',
    },
    importConflictsOpen: 'Opna innflutningsárekstra',
    importConflictsCount: 'INNFLUTNINGSÁREKSTRAR: {{count}}',
    importConflictsTitle: 'INNFLUTNINGSÁREKSTRAR',
    importConflictExistingConfirmed: 'Núverandi skýrsla staðfest',
    compareConflict: 'Bera saman',
    importConflictAuthoritativeHint:
      'Staðfesta skýrslan er áfram heimild þar til tekin er skýr ákvörðun.',
    quickPeriods: 'Hraðt tímabil',
    weekPeriods: 'Vikur',
    isoYear: 'Ár',
    isoWeek: 'Vika',
    isoWeekOption: 'Vika {{week}} · {{range}}',
    notDue: 'Ekki komið á gjalddaga',
    activeRange: '{{from}} – {{to}}',
    expandFilters: 'Sýna síur',
    collapseFilters: 'Fela síur',
    columns: 'Dálkar',
    searchColumns: 'Leita í dálkum',
    showAllColumns: 'Sýna alla',
    hideAllColumns: 'Fela alla',
    allMatrixColumns: 'Allir dálkar',
    visibleColumnsCount: 'Sýnilegir: {{visible}} / {{total}}',
    columnSearchResults: 'Leitarniðurstöður',
    showSearchResults: 'Sýna leitarniðurstöður',
    hideSearchResults: 'Fela leitarniðurstöður',
    noColumnSearchResults: 'Engir dálkar fundust',
    noProductsSelected: 'Engar vörur valdar',
    noStoresSelected: 'Engar verslanir valdar',
    pinColumn: 'Festa fremst',
    resetColumnLayout: 'Endurstilla uppsetningu',
    resetRowOrder: 'Endurstilla röðun raða',
    pieceAbbreviation: 'stk.',
    kgAbbreviation: 'kg',
    preset: {
      '7d': '7 dagar',
      '28d': '28 dagar',
      '90d': '90 dagar',
      ytd: 'ÁRSINS',
      last_confirmed_day: 'Síðasti dagur',
      last_2_confirmed_days: 'Síðustu 2 dagar',
      last_3_confirmed_days: 'Síðustu 3 dagar',
      last_7_calendar_days: 'Síðustu 7 dagar',
      last_completed_weekend: 'Síðasta helgi',
      current_week: 'Þessi vika',
      previous_week: 'Síðasta vika',
      iso_week: 'Velja viku',
      custom: 'Sérsniðið tímabil',
    },
  },
  salesImports: {
    title: 'Söluskýrslur',
    description:
      'Hlaða upp, sannreyna, staðfesta og afturkalla opinberar daglegar Sales Pivot skrár.',
    upload: 'Hlaða upp vinnubók',
    history: 'Innflutningssaga',
    filename: 'Skráarheiti',
    salesDate: 'Söludagur',
    status: 'Staða',
    statusValue: {
      UPLOADED: 'Hlaðið upp',
      PROCESSING: 'Í vinnslu',
      PREVIEW_READY: 'Tilbúið til staðfestingar',
      BLOCKED: 'Lokað',
      DUPLICATE: 'Tvítekið',
      DATE_CONFLICT: 'Gagnaárekstur',
      FAILED: 'Innflutningur mistókst',
      CONFIRMED: 'Staðfest',
      CANCELLED: 'Hætt við',
      ROLLED_BACK: 'Afturkallað',
    },
    uploaded: 'Hlaðið upp',
    stores: 'Verslanir',
    products: 'Vörur',
    nonzero: 'Færslur sem eru ekki núll',
    total: 'Heildarmagn',
    mappings: 'Vörpun og sannprófun',
    issues: 'Athugasemdir úr sannprófun',
    canonicalIdentityConflict:
      'Nokkur upprunaauðkenni vísa á sömu kanónísku vöru en ekki er hægt að leggja þau örugglega saman.',
    canonicalizedProductsNotice:
      'Nokkur sannreynd upprunaauðkenni hafa verið lögð saman í kanónísku vöruna. Sérhver frumreitur er áfram tiltækur til endurskoðunar.',
    canonicalizedSourceCells: 'Sameinaðir frumreitir',
    sourceCell: 'Frumreitur',
    sourceQuantity: 'Frummagn',
    nonRetailWarehouseDestination: 'Útilokað — áfangastaður er vöruhús, ekki verslun',
    storeIdentityMissing: 'Lokað — auðkenni verslunar vantar',
    distributionPolicyMissing: 'Dreifingarstefnu vantar fyrir vöru {{sku}} {{product}}',
    fixDistributionPolicy: 'Laga stefnu',
    resolveStore: 'Bæta við eða tengja verslun',
    issueOccurrences: '{{count}} tilvik',
    sample: 'Sýnishorn úr lestri',
    confirm: 'Staðfesta opinbera skýrslu',
    revalidate: 'Sannreyna vörpun aftur',
    retry: 'Reyna aftur frá vistuðu frumriti',
    rollback: 'Afturkalla skýrslu',
    rollbackReason: 'Ástæða afturköllunar er nauðsynleg',
    detail: 'Upplýsingar um skýrslu',
    duplicate: 'Tvítekið — þessi gögn eru þegar staðfest.',
    showExistingReport: 'Sýna núverandi skýrslu',
    conflict: 'Nýja heimildin inniheldur önnur gögn en staðfesta skýrslan fyrir þennan dag.',
    conflictComparisonTitle: 'Samanburður á innflutningsárekstri',
    conflictComparisonDescription:
      'Berðu saman staðfestu skýrsluna við nýju heimildina. Breyting krefst skýrrar ákvörðunar.',
    existingConfirmedReport: 'NÚVERANDI SKÝRSLA — STAÐFEST',
    conflictingEvidence: 'NÝ HEIMILD — ÁREKSTUR',
    conflictScope: 'Verslanir: {{stores}} · Vörur: {{products}}',
    conflictDifferences: 'Breyttar verslun × vara línur',
    store: 'Verslun',
    product: 'Vara',
    existingValue: 'Núverandi',
    newValue: 'Nýtt gildi',
    difference: 'Mismunur',
    keepExistingReport: 'Halda núverandi skýrslu',
    replaceWithNewReport: 'Skipta út fyrir nýja skýrslu',
    replaceConfirm:
      'Skipta út staðfestri söluskýrslu fyrir nýju útgáfuna? Fyrri skýrslan verður varðveitt sem söguleg heimild og dagurinn endurreiknaður úr nýju skýrslunni.',
    replaceBack: 'Til baka',
    keepConfirm:
      'Halda núverandi staðfestri skýrslu sem opinberri söluheimild. Nýja skráin varðveitist sem óbreytanleg árekstraheimild.',
    conflictReason: 'Rökstuðningur ákvörðunar',
    conflictReasonHelp:
      'Nauðsynlegt fyrir endurskoðun. Lýstu hvers vegna skýrslan helst eða er skipt út.',
    conflictAdminReason:
      'Aðeins kerfisstjóri getur tekið þessa skráðu ákvörðun. Rökstuðningur er nauðsynlegur.',
    confirmConflictDecision: 'Staðfesta skráða ákvörðun',
    conflictStepExplain: 'Árekstur',
    conflictStepCompare: 'Samanburður',
    conflictStepDecision: 'Ákvörðun',
    conflictStepConfirm: 'Staðfesting',
    conflictRows_one: '{{count}} lína önnur en núll',
    conflictRows_other: '{{count}} línur aðrar en núll',
    changeType: 'Breyting',
    changeTypeValue: { ADDED: 'Bætt við', REMOVED: 'Fjarlægt', CHANGED: 'Breytt' },
    conflictHelpTitle: 'Hvernig leysi ég árekstur?',
    conflictHelpBody:
      'Berðu saman heimild, innsendanda, tíma, umfang, línufjölda og hvert breytt Verslun × Vara gildi. Haltu núverandi skýrslu þegar hún er enn opinber. Skiptu aðeins út þegar nýja heimildin er leiðrétt opinber skýrsla; fyrri skýrslan varðveitist í sögu.',
    conflictResolution: {
      KEEP_EXISTING: 'Árekstur yfirfarinn. Núverandi staðfesta skýrslan er áfram heimild.',
      REPLACED: 'Ný útgáfa skýrslunnar hefur verið staðfest. Fyrri útgáfan er í sögunni.',
    },
    completeZero: 'Heil skýrsla án færslu þýðir þekkt núll. Skýrsla sem vantar er óþekkt.',
    choose: 'Veldu .xlsx Sales Pivot vinnubók',
    back: 'Til baka í innflutningssögu',
    download: 'Sækja upprunalega skrá',
    operationFailed: 'Ekki tókst að framkvæma söluflutning.',
  },
  importCenter: {
    email: {
      source: 'Tölvupóstur',
      sourceFilter: 'Uppruni',
      browserSource: 'Hlaðið upp í vafra',
      title: 'Innflutningur viðhengja úr tölvupósti',
      settings: 'Stjórnun tölvupósts',
      safety:
        'Móttaka tölvupósts undirbýr og sannreynir aðeins viðhengi. Staðfesting er handvirk; engar sölu-, sendinga-, birgða- eða flæðifærslur verða til sjálfkrafa.',
      configured:
        'Uppsetningu forritsins er lokið. Staðfesta þarf DNS og raunverulega móttöku sérstaklega áður en kveikt er á þjónustunni.',
      notConfigured:
        'Móttaka tölvupósts hefur ekki verið stillt. Netföng eru ekki virk. Fylgdu leiðbeiningum um virkjun á STAGING.',
      disabled: 'Slökkt er á móttöku tölvupósts.',
      enabled: 'Virkja innflutning tölvupóstviðhengja',
      addressMissing: 'Netfang ekki stillt',
      addressActive: 'Virkt í stillingum forritsins',
      addressInactive: 'Óvirkt — ekki senda skýrslur hingað',
      copyAddress: 'Afrita {{type}} netfang',
      copied: 'Netfang afritað.',
      copyFailed: 'Ekki tókst að afrita. Veldu virka netfangið handvirkt.',
      authenticationPolicy:
        'Sjálfvirkur innflutningur krefst heimilaðs sendanda og skýrslugerðar og SPF, DKIM og DMARC pass frá Resend. Aðeins jakub@kjotkompani.is má nota samþykkta DKIM gray undantekningu með SPF og DMARC pass; DKIM fail eða unknown er aldrei samþykkt. Aðrar óvissar niðurstöður fara í sóttkví. Staðfesting skýrslu er áfram handvirk.',
      autoReleaseEnabled: 'Flytja sjálfvirkt inn auðkenndan póst frá heimiluðum sendendum',
      providerVerified:
        'Sjálfvirkt leyst úr sóttkví samkvæmt samþykktri auðkenningarstefnu sendanda með niðurstöðum Resend. Staðfesting skýrslu er áfram handvirk.',
      senders: 'Heimilaðir sendendur og skýrslugerðir',
      senderAddress: 'Netfang sendanda',
      addSender: 'Bæta við sendanda',
      removeSender: 'Fjarlægja sendanda',
      limits:
        'Mörk: {{attachments}} viðhengi; {{fileBytes}} bæti á skrá; {{totalBytes}} bæti á póst.',
      reason: 'Ástæða fyrir atvikaskrá',
      reasonHint: 'Að minnsta kosti 10 stafir. Ekki skrá leyndarmál eða innihald pósts.',
      actionFailed:
        'Aðgerð var ekki samþykkt. Athugaðu stillingar, heimildir sendanda, núverandi stöðu og tilraunamörk og endurhlaðaðu síðan.',
      settingsFailed: 'Ekki tókst að sækja tölvupóststillingar.',
      cancel: 'Hætta við',
      save: 'Vista stillingar',
      proceed: 'Halda áfram',
      refresh: 'Endurhlaða',
      empty: 'Enginn móttekinn tölvupóstur passar við síuna.',
      typeUnresolved: 'Skýrslugerð óákveðin',
      counts:
        'Viðhengi {{total}} · unnin {{processed}} · sleppt {{skipped}} · villur {{failed}} · í bið {{pending}}',
      adminApproved: 'Stjórnandi yfirfór gögn sendanda og samþykkti póstinn.',
      unverified: 'Auðkenning sendanda er óstaðfest.',
      release: 'Yfirfara / leysa úr sóttkví',
      retry: 'Reyna aftur ólokin viðhengi',
      attachments: 'Viðhengi og uppruni ({{total}})',
      identifiers: 'Póstauðkenni þjónustuaðila: {{provider}} · Message-ID: {{messageId}}',
      attachmentMeta: '{{size}} bæti · tilraunir {{attempts}}',
      unknown: 'Óþekkt',
      pendingHash: 'Ekki vistað enn',
      provenance:
        'Viðhengi þjónustuaðila: {{attachment}} · import_file: {{file}} · safnliður: {{item}}',
      reviewReport: 'Yfirfara sannprófun / skýrslu',
      releaseWarning:
        'Staðfestu sendandann með óháðum hætti áður en þú samþykkir. Sendandi og skýrslugerð verða áfram að vera heimiluð. Þetta leyfir aðeins undirbúning, aldrei staðfestingu.',
      retryWarning:
        'Aðeins ólokin eða misheppnuð vinna er endurtekin, innan tilraunamarka þjónsins. Lokið viðhengi og viðskiptafærslur eru ekki tvítekin.',
      statusRECEIVED: 'Móttekið',
      statusPROCESSING: 'Í vinnslu',
      statusQUARANTINED: 'Í sóttkví',
      statusREADY: 'Tilbúið fyrir handvirka staðfestingu',
      statusBLOCKED: 'Sannprófun stöðvuð',
      statusDUPLICATE: 'Tvítekning',
      statusCOMPLETED_WITH_ERRORS: 'Lokið með villum',
      statusFAILED: 'Mistókst',
      statusPENDING: 'Í bið',
      statusSKIPPED: 'Sleppt',
      statusCOMPLETED: 'Lokið',
      statusCONFIRMED: 'Staðfest handvirkt',
      statusCANCELLED: 'Hætt við',
      statusROLLED_BACK: 'Afturkallað',
      pageSummary: 'Póstar {{from}}–{{to}} af {{total}}',
      previousPage: 'Fyrri póstar',
      nextPage: 'Næstu póstar',
      reasonAuthentication:
        'Staðfestu sendandann með óháðum hætti og óskaðu síðan eftir samþykki stjórnanda.',
      reasonSender: 'Sendandi eða skýrslugerð er ekki heimiluð. Yfirfarðu leyfislista stjórnanda.',
      reasonRecipient:
        'Viðtakandi ákvarðar ekki nákvæmlega eina skýrslugerð. Notaðu eitt stillt móttökunetfang.',
      reasonUnsupported: 'Óstuddum viðhengjum var sleppt; önnur viðhengi halda áfram í vinnslu.',
      reasonLimit: 'Öryggismörk skráar, pósts eða vinnubókar voru yfirfarin.',
      reasonWorkbook:
        'Viðhengið er ekki gild, studd XLSX-vinnubók. Óskaðu eftir leiðréttri frumskrá.',
      reasonUnsafe:
        'Dulkóðuðu, keyranlegu, formúlutengdu eða öðru óöruggu efni vinnubókar var hafnað.',
      reasonValidation:
        'Núverandi skýrslugreinir hafnaði frumskránni. Yfirfarðu sannprófun áður en reynt er aftur.',
      reasonTechnical:
        'Vinnslan þarfnast athygli. Varðveittu frumskrána og tilkynntu þennan villukóða ef endurtekning mistekst.',
    },
    title: 'Innflutningsmiðstöð',
    description: 'Rekstrarinnhólf fyrir sölu- og sendingarskýrslur.',
    loading: 'Hleð innflutningum…',
    loadFailed: 'Ekki tókst að hlaða innflutningsmiðstöð.',
    dateUnknown: 'Dagsetning bíður staðfestingar',
    scopeUnknown: 'Umfang bíður staðfestingar',
    openBatch: 'Opna lotu',
    backToInbox: 'Til baka í innhólf',
    salesBatch: 'Sölulota',
    shipmentBatch: 'Sendingarlota',
    batchItems: 'Skrár í lotu',
    businessDates_one: '{{count}} skýrsludagur',
    businessDates_other: '{{count}} skýrsludagar',
    confirmAllSafety: 'Aðeins skýrslur sem uppfylla gildandi reglur eru staðfestar.',
    confirmResult:
      'Staðfest {{confirmed}}; áður staðfest {{already_confirmed}}; lokað {{blocked}}; villur {{failed}}.',
    tabs: {
      label: 'Hlutar innflutningsmiðstöðvar',
      actions: 'Krefst aðgerðar',
      missing: 'Skýrslur vantar',
      history: 'Saga',
      upload: 'Fjöldainnflutningur',
    },
    filters: {
      from: 'Frá',
      to: 'Til',
      type: 'Tegund',
      all: 'Allt',
      network: 'Keðja',
      store: 'Verslun',
      search: 'Skrá, dagsetning eða auðkenni',
      filename: 'Skráarheiti',
      reportDate: 'Dagsetning skýrslu',
      status: 'Staða',
      sort: 'Röðun',
      ascending: 'Hækkandi',
      descending: 'Lækkandi',
      showTestData: 'Sýna prófunargögn',
    },
    columns: {
      report: 'Skýrsla',
      source: 'Heimild',
      scope: 'Umfang',
      reason: 'Ástæða',
      counts: 'Línur',
      quantity: 'Magn',
      action: 'Aðgerð',
      date: 'Dagsetning',
      type: 'Tegund',
      deadline: 'Væntanlegt fyrir',
      state: 'Staða',
      uploader: 'Hlaðið upp af',
      identifier: 'Auðkenni',
    },
    actions: {
      title: 'Skýrslur sem krefjast aðgerðar',
      previousStatus: 'Fyrri skýrsla: {{status}}',
      rows: '{{count}} línur',
      valid: '{{count}} gildar',
      errors: '{{count}} villur',
      unrecognized: '{{count}} óþekktar',
      emptyTitle: 'Engrar aðgerðar þörf',
      emptyBody: 'Enginn innflutningur krefst aðgerðar núna.',
      retry: 'Reyna aftur',
      viewIssues: 'Skoða vandamál',
      preview: 'Forskoða / staðfesta',
      openReport: 'Opna skýrslu',
      processing: 'Í vinnslu',
      confirmAll: 'Staðfesta allt tilbúið',
      recalculateBatchStatus: 'Endurreikna stöðu lotu',
      revalidate: 'Staðfesta aftur',
      revalidateBackfill: 'Staðfesta daga aftur',
    },
    statusReconciliation: {
      title: 'Endurreikna stöðu lotu',
      loading: 'Athuga staðfesta stöðu skýrslna…',
      safety:
        'Aðgerðin samstillir aðeins rekstrarstöðu skrár við þegar staðfesta skýrslu. Hún keyrir hvorki þáttun, sannprófun né staðfestingu og breytir ekki skýrslum eða færslum.',
      current: 'Núna: {{status}}',
      expected: 'Eftir leiðréttingu: {{status}}',
      eligible: 'Til samstillingar: {{count}}',
      excluded: 'Utan umfangs: {{count}}',
      currentState: 'Staða skrár',
      authoritativeState: 'Staða skýrslu',
      scope: 'Umfang leiðréttingar',
      included: 'Innifalið í leiðréttingu',
      exclusionITEM_NOT_PREVIEW_READY: 'Staða skrár uppfyllir ekki skilyrði',
      exclusionDOMAIN_BATCH_MISSING: 'Tengd lénsskýrsla finnst ekki',
      exclusionDOMAIN_BATCH_NOT_CONFIRMED: 'Lénsskýrslan er ekki staðfest',
      noDrift: 'Stöður þessarar lotu eru þegar samstilltar.',
      zeroEffects: 'Skýrslur, færslur, staðfestingaratburðir, vörpun og reglur: 0 breytingar.',
      reason: 'Skyldubundin ástæða',
      reasonHelp: 'Notandi, tími og nákvæmt fyrra og nýtt ástand eru skráð í úttekt.',
      confirmation: 'Sláðu inn {{value}}',
      cancel: 'Hætta við',
      apply: 'Endurreikna stöðu',
      saving: 'Vista…',
      previewFailed: 'Ekki tókst að útbúa forskoðun. Endurnýjaðu lotuna og reyndu aftur.',
      failed: 'Staða breyttist eða samstilling mistókst. Ekkert var vistað.',
      success: '{{count}} skrár samstilltar. Staða lotu: {{status}}.',
    },
    conflicts: {
      title: 'Innflutningsárekstrar',
      description: 'Berðu ný gögn saman við virkar staðfestar skýrslur.',
      grouping: 'Flokkun árekstra',
      groupByReport: 'Eftir skýrslu',
      groupBySourceUpload: 'Eftir upprunaupphali',
      sourceCardLabel: 'Árekstrar úr skránni {{filename}}',
      sourceUploadedBy: 'Hlaðið upp af: {{uploader}} · {{date}}',
      sourceDateRange: 'Dagabil: {{from}}–{{to}}',
      sourceConfirmed: 'Staðfestir hlutar: {{count}} · færslur: {{facts}}',
      sourceConflicts: 'Árekstrar sem á að loka: {{count}}',
      sourceConflictBreakdown: 'Mismunur: {{material}} · lokað: {{blocked}}',
      sourceOtherBlocked: 'Aðrir lokaðir hlutar: {{count}}',
      sourceKeepEffect:
        'Heldur opinberu skýrslunum. Staðfest gögn og aðrir lokaðir hlutar upphalsins breytast ekki.',
      closeSourceConflicts: 'Halda opinberum skýrslum og loka {{count}} árekstrum úr þessu upphali',
      sourceEmptyTitle: 'Engin upphöl með opna árekstra',
      sourceEmptyBody: 'Ekkert upprunaupphal inniheldur árekstra sem þarf að loka.',
      sourceKeepTitle: 'Halda opinberum skýrslum fyrir upprunaupphalið',
      sourcePreservedEvidence:
        'Skráin, upprunagögn, athugasemdir og staðfestar skýrslur haldast óbreytt.',
      sourceEvidenceDifferences:
        'Mismunur í upprunanum sem er lokað — aðeins til upplýsinga og verður ekki skráður sem færslur',
      sourceExpectedEffects:
        'Áhrif aðgerðar: Sales-skýrslur {{reports}}, Sales-færslur {{facts}}, staðfestingar {{confirmations}}, vörpun {{mappings}}, reglur {{policies}}, endurstaðfestingar {{revalidations}}.',
      total: 'Samtals: {{count}}',
      materialCount: 'Viðskiptamunur: {{count}}',
      blockedCount: 'Lokað: {{count}}',
      classification: 'Flokkun',
      classificationEXACT_DUPLICATE: 'Nákvæmt afrit',
      classificationMETADATA_ONLY: 'Aðeins lýsigögn',
      classificationMATERIAL_DIFFERENCE: 'Viðskiptamunur',
      classificationBLOCKED: 'Lokað',
      existingReport: 'Núverandi skýrsla',
      newReport: 'Ný skýrsla',
      changed: 'Breytt',
      added: 'Bætt við',
      removed: 'Fjarlægt',
      negatives: 'Neikvætt',
      recommendation: 'Tillaga',
      recommendationKEEP_EXISTING: 'Halda núverandi',
      recommendationCOMPARE: 'Bera saman og ákveða',
      recommendationRESOLVE_BLOCKERS: 'Leysa hindranir fyrst',
      compare: 'Bera saman',
      openFullComparison: 'Fullur samanburður',
      factCount: '{{count}} færslur',
      selectPage: 'Velja þessa síðu',
      clearPage: 'Hreinsa þessa síðu',
      selectAllResults: 'Velja allar niðurstöður',
      clearAll: 'Hreinsa allt',
      selectedCount: 'Valið: {{count}}',
      selectReport: 'Velja skýrslu dagsetta {{date}}',
      allFilteredSelected: 'Allar ólokaðar niðurstöður síunnar eru valdar.',
      keepExisting: 'Halda núverandi',
      replaceWithNew: 'Skipta út fyrir nýjar',
      keepTitle: 'Halda núverandi skýrslum',
      replaceTitle: 'Skipta virkum skýrslum út fyrir nýjar',
      previewCounts: 'Gjaldgengar: {{eligible}} · útilokaðar: {{excluded}}',
      excludedReports: 'Útilokaðar skýrslur og ástæður',
      reason: 'Skyldubundin sameiginleg ástæða',
      confirmationText: 'Sláðu inn {{value}}',
      acceptNegatives: 'Ég samþykki {{count}} neikvæðar leiðréttingar',
      cancel: 'Hætta við',
      execute: 'Framkvæma',
      executing: 'Framkvæmi…',
      operationFailed: 'Ekki tókst að undirbúa eða framkvæma aðgerðina. Endurnýjaðu samanburðinn.',
      retryIncomplete: 'Reyna ólokið aftur',
      partitionResults: 'Niðurstöður hluta ({{count}})',
      partitionResultsLabel: 'Niðurstöður aðgerðar fyrir upprunahluta',
      partitionResult: 'Niðurstaða',
      none: 'Ekkert',
      operationStatus:
        '{{status}} · lokið {{completed}} · sleppt {{skipped}} · mistókst {{failed}}',
      operationStatusPENDING: 'Bíður',
      operationStatusRUNNING: 'Í gangi',
      operationStatusPARTIAL: 'Lauk að hluta',
      operationStatusCOMPLETED: 'Lokið',
      operationStatusSKIPPED: 'Sleppt',
      operationStatusFAILED: 'Mistókst',
      guardTEST_FIXTURE: 'Prófunargögn eru undanskilin',
      guardNOT_MATERIAL_DIFFERENCE: 'Skýrslan inniheldur engan rekstrarmun',
      guardUNIT_MISMATCH: 'Einingar skýrslnanna passa ekki saman',
      guardUNKNOWN_UNIT: 'Skýrslan inniheldur óstudda einingu',
      guardACTIVE_REPORT_COUNT_CHANGED: 'Fjöldi virkra skýrslna hefur breyst',
      guardPARALLEL_CONFLICT: 'Fleiri en einn árekstur er fyrir þessa dagsetningu',
      guardSEMANTIC_HASH_MISSING: 'Fullkomið gagnaspor skýrslunnar vantar',
      guardSOURCE_EVIDENCE_MISSING: 'Óbreytanlega tengingu við upprunaupphalið vantar',
      guardSOURCE_EVIDENCE_MISMATCH: 'Óbreytanleg sönnun upprunaupphalsins passar ekki lengur',
      guardAUTHORITATIVE_REPORT_NOT_CONFIRMED:
        'Skýrslan sem var valin sem opinber er ekki lengur staðfest',
      guardIMPORT_CONFLICT_STATE_CHANGED:
        'Staða skýrslunnar eða upprunagagnanna breyttist eftir forskoðun',
      guardIMPORT_CONFLICT_OPERATION_FAILED:
        'Ekki tókst að loka þessum hluta; óloknar færslur má reyna aftur á öruggan hátt',
      guardSHIPMENT_RECONCILIATION_REQUIRED: 'Ljúka þarf afstemmingu sendingar',
      guardSHIPMENT_PARTIAL_RANGE_REPLACE_UNSAFE:
        'Styttri heimild má ekki koma í stað allrar staðfestu sendingarskýrslunnar',
      emptyTitle: 'Engir opnir árekstrar',
      emptyBody: 'Engin skýrsla þarf samanburð við staðfesta skýrslu.',
    },
    incompleteSource: {
      title: 'Hafna ófullkomnum upprunahlutum',
      selectedCount: 'Valdir ófullkomnir hlutar: {{count}}',
      selectEligible: 'Velja gjaldgenga á þessari síðu',
      clearSelection: 'Hreinsa val',
      previewAction: 'Forskoða höfnun',
      preparing: 'Undirbý forskoðun…',
      previewFailed: 'Ekki tókst að útbúa forskoðun. Endurhlaðið innhólfið og reynið aftur.',
      selectPartition: 'Velja ófullkominn hluta úr {{filename}}',
      select: 'Velja til höfnunar',
      previewCounts: 'Valið: {{selected}} · gjaldgengt: {{eligible}} · útilokað: {{excluded}}',
      eligible: 'Gjaldgengt',
      excluded: 'Útilokað',
      blockers: 'Lokandi upprunagögn',
      unknownBlocker: 'Óleyst lokandi vandamál',
      quantityTotals: 'Upprunamagn sem er ekki núll',
      entityCounts: 'Verslanir: {{stores}} · Vörur: {{products}}',
      sourceRows: 'Upprunareitir sem eru ekki núll: {{cells}} · línur {{first}}–{{last}}',
      blankStoreEvidence: 'Sönnun um auða verslun: {{count}} ótengdir upprunadálkar',
      currentEffects:
        'Núverandi rekstraráhrif — skýrslur: {{reports}} · færslur: {{facts}} · virkar staðfestar skýrslur: {{confirmed}}',
      sharedSource:
        'Sameiginlegur uppruni — hlutar: {{partitions}} · staðfestir: {{confirmed}} · tvítekningar: {{duplicates}} · staðfestar færslur: {{facts}}',
      exclusionReasons: 'Ekki hægt að hafna',
      notEligible: 'Þessi hluti er ekki lengur gjaldgengur',
      effect:
        'Hlutar færðir í HÆTT VIÐ: {{count}}. Söluskýrslur: {{reports}}; sölufærslur: {{facts}}. Engar tengingar, staðfestingar, endurstaðfestingar, eyðingar eða breytingar á sameiginlegri skrá verða gerðar. Þekja hvers dags verður áfram VANTAR (óþekkt), aldrei núll.',
      reason: 'Ástæða höfnunar er nauðsynleg',
      reasonHelp: 'Ástæðan varðveitist í óbreytanlegri endurskoðunarslóð.',
      confirmationText: 'Sláðu nákvæmlega inn: {{value}}',
      confirmationHelp: 'Textinn verður að passa nákvæmlega við forskoðun þjónsins.',
      reject: 'Hafna ófullkomnum uppruna',
      rejecting: 'Hafna…',
      cancel: 'Hætta við',
      close: 'Loka',
      operationFailed:
        'Ekki tókst að hafna ófullkomna upprunanum. Endurhlaðið innhólfið og útbúið nýja forskoðun.',
      operationId: 'Auðkenni aðgerðar: {{operationId}}',
      replayed: 'Ítrekuð óbreytanleg beiðni',
      result: '{{status}} · lokið {{completed}} · sleppt {{skipped}} · mistókst {{failed}}',
      resultsLabel: 'Niðurstöður höfnunar ófullkomins uppruna',
      resultStatusCOMPLETED: 'Lokið',
      resultStatusPARTIAL: 'Lokið að hluta',
      resultStatusFAILED: 'Mistókst',
      outcomeStatusCOMPLETED: 'Hætt við',
      outcomeStatusSKIPPED: 'Sleppt',
      outcomeStatusFAILED: 'Mistókst',
      none: 'Ekkert',
      partitionFailed: 'Ekki tókst að hafna þessum hluta',
      errorCodeIMPORT_INCOMPLETE_SOURCE_STATE_CHANGED: 'Upprunagögn breyttust eftir forskoðun',
      errorCodeIMPORT_INCOMPLETE_SOURCE_NOT_REJECTABLE: 'Þessi hluti er ekki lengur gjaldgengur',
      errorCodeIMPORT_INCOMPLETE_SOURCE_PREVIEW_MISMATCH:
        'Forskoðunin passar ekki lengur við beiðnina',
      errorCodeIMPORT_INCOMPLETE_SOURCE_CONFIRMATION_MISMATCH: 'Staðfestingartextinn passaði ekki',
      guardIMPORT_TYPE_NOT_SUPPORTED: 'Aðeins söluhlutar eru studdir',
      guardSTATUS_NOT_BLOCKED: 'Þessi hluti er ekki lengur lokaður',
      guardSOURCE_PARTITION_MISSING: 'Óbreytanleg upprunasönnun hlutans vantar',
      guardALREADY_CONFIRMED: 'Þessi hluti hefur þegar verið staðfestur',
      guardIS_DUPLICATE: 'Þessi hluti er tvítekning',
      guardIS_CONFLICT: 'Þessi hluti er með innflutningsárekstur',
      guardHAS_BUSINESS_EFFECT: 'Þessi hluti hefur þegar rekstraráhrif',
      guardDATE_ALREADY_CONFIRMED: 'Dagsetningin er þegar með staðfesta skýrslu',
      guardIS_DUPLICATE_CANONICAL:
        'Annar innflutningur vísar á þennan hluta sem uppruna tvítekningar',
      guardHAS_CONFLICT_RESOLUTION: 'Árekstrarákvörðun er þegar til fyrir þennan hluta',
      guardTEST_DATA_USES_SEPARATE_WORKFLOW: 'Prófunargögn nota sérstakt verkflæði',
      guardNO_BLOCKING_ISSUE: 'Ekkert lokandi vandamál er eftir',
      guardNO_EMPTY_UNKNOWN_STORE_EVIDENCE: 'Enginn auður óþekktur verslunarblokkari fannst',
      guardNO_EMPTY_UNMAPPED_STORE_EVIDENCE: 'Engin auð ótengd verslun fannst',
      guardHAS_ADDITIONAL_BLOCKING_ISSUES:
        'Hlutinn hefur fleiri lokandi vandamál og þarfnast sérstakrar ákvörðunar',
      guardHAS_NON_EMPTY_OR_MAPPED_STORE_EVIDENCE:
        'Hlutinn inniheldur þekkta eða óauða verslun og ekki er hægt að hafna honum í heild',
      guardNO_FRAGMENTARY_ROWS: 'Engar brotakenndar upprunalínur með magni fundust',
    },
    productIssues: {
      title: 'Sameiginleg vandamál',
      description:
        'Ein vörutenging getur örugglega losað allar óstaðfestar skýrslur með sama upprunakóða.',
      sourceSku: 'Upprunakóði',
      sourceNames: 'Heiti í uppruna',
      affectedReports: 'Skýrslur sem breytast',
      reportCount_one: '{{count}} skýrsla',
      reportCount_other: '{{count}} skýrslur',
      dateRange: 'Dagabil',
      occurrences: 'Tilvik',
      resolve: 'Leysa',
      openCommonIssue: 'Opna sameiginlegt vandamál',
      adminRequired: 'Kerfisstjóri nauðsynlegur',
      resolveTitle: 'Leysa óþekkta vöru {{sku}}',
      sourceAttributesUnavailable:
        'Sales Pivot veitir hvorki staðfesta einingu né nettóþyngd. Veldu þau sérstaklega þegar vara er stofnuð; kerfið giskar ekki.',
      examples: 'Dæmi úr uppruna',
      matchExisting: 'Tengja við núverandi vöru',
      searchProducts: 'Leita eftir SKU, heiti eða samheiti',
      decisionPreview: 'Forskoðun ákvörðunar og samheitis',
      canonicalAttributes: 'Eining: {{unit}} · Nettóþyngd: {{weight}}',
      notSet: 'óskráð',
      existingAliases_one: 'Varan er með {{count}} núverandi samheiti.',
      existingAliases_other: 'Varan er með {{count}} núverandi samheiti.',
      reason: 'Rökstuðningur ákvörðunar',
      reasonHelp: 'Rökstuðningurinn varðveitist í rekjanleika og uppruna samheitis.',
      resolveFailed: 'Ekki tókst að vista ákvörðunina og endurmeta skýrslurnar.',
      technicalDetail: 'Tæknilegt atriði: {{code}}',
      resultSummary:
        'Vörpun vistuð. Alls {{total}}, tilbúnar {{ready}}, enn lokaðar {{blocked}}, endurmat mistókst {{failed}}.',
      previousAliases_one: '{{count}} eldra samheiti fannst fyrir þennan upprunakóða.',
      previousAliases_other: '{{count}} eldri samheiti fundust fyrir þennan upprunakóða.',
      active: 'virkt',
      leaveUnresolved: 'Skilja óleyst',
      createNew: 'Stofna nýja vöru',
      resolving: 'Vista og endurmeta…',
      retryFailed: 'Reyna aftur misheppnaðar gildanir',
      retrying: 'Endurmeta aftur…',
      matchAndRevalidate: 'Tengja og endurmeta skýrslur',
    },
    storeIssues: {
      title: 'Nýjar verslanir og vörur — verslanir',
      description: 'Tengdu heiti úr uppruna eða stofnaðu verslun án þess að giska á keðju.',
      sourceIdentity: 'Heiti verslunar í uppruna',
      type: 'Tegund innflutnings',
      affectedReports: 'Skýrslur sem ákvörðunin nær til',
      dateRange: 'Dagsetningar',
      candidates: 'Mögulegar núverandi verslanir',
      noCandidates: 'Enginn öruggur kostur',
      resolve: 'Bæta við eða tengja verslun',
      resolveTitle: 'Leysa verslun {{name}}',
      noAutomaticMatch: 'Kerfið skiptir ekki sjálfkrafa um verslun eða keðju.',
      reportCount_one: '{{count}} skýrsla',
      reportCount_other: '{{count}} skýrslur',
      occurrenceCount_one: '{{count}} tilvik',
      occurrenceCount_other: '{{count}} tilvik',
      reports: 'Skýrslur og dagsetningar',
      examples: 'Dæmi úr uppruna',
      matchExisting: 'Tengja við núverandi verslun',
      createNew: 'Bæta við nýrri verslun',
      searchStores: 'Leita eftir verslun eða keðju',
      canonicalName: 'Heiti verslunar',
      shortName: 'Stutt heiti (valfrjálst)',
      network: 'Verslunarkeðja',
      networkRequired: 'Velja verður verslunarkeðju sérstaklega.',
      manageNetworks: 'Opna verslunarkeðjuskrá',
      activityDateSeparate: 'Fyrsta tilvik sannar ekki opnunardag verslunar.',
      effectiveFrom: 'Samheiti gildir frá',
      effectiveTo: 'Samheiti gildir til (ekki með, valfrjálst)',
      aliasDateHelp: 'Tímabilið á aðeins við um vörpun upprunaheitis.',
      reason: 'Ástæða ákvörðunar (áskilið)',
      reasonHelp: 'Gerandi, ákvörðun, verslun, keðja og samheiti varðveitast í úttekt.',
      resolveFailed: 'Ekki tókst að vista ákvörðun eða sannreyna skýrslur aftur.',
      resultSummary: 'Alls {{total}}, tilbúnar {{ready}}, lokaðar {{blocked}}, villur {{failed}}.',
      leaveUnresolved: 'Skilja óleyst',
      saveAndRevalidate: 'Vista og athuga skýrslu',
      revalidating: 'Vista og sannreyna…',
      retry: 'Halda áfram misheppnaðri sannprófun',
      locationOnlyWarning: '{{store}} ({{network}}) er ekki sjálfkrafa sama verslun.',
      matchBasis_EXACT_CANONICAL: 'nákvæmt skráarheiti',
      matchBasis_EXACT_ALIAS: 'nákvæmt núverandi samheiti',
      matchBasis_LOCATION_TOKEN: 'svipað staðarheiti — yfirferð nauðsynleg',
    },
    distributionIssues: {
      title: 'Dreifingarstefnu vantar',
      summary: 'Dreifingarstefnu vantar: {{products}} vörur · {{reports}} skýrslur',
      product: 'Vara',
      sourceSku: 'Upprunakóði',
      sourceName: 'Heiti í uppruna',
      sourceNames: 'Heiti í uppruna',
      scope: 'Umfang',
      dateRange: 'Dagsetningar skýrslna',
      counts: 'Tilvik',
      currentPolicies: 'Núverandi stefnur',
      noPolicies: 'Engin',
      fixPolicy: 'Laga stefnu',
      resolveTitle: 'Stilla dreifingarstefnu',
      explanation:
        'Dreifingarstefnu vantar fyrir vöru {{sku}} {{product}} í {{network}}. Vara í skýrslu er ekki sjálfkrafa samþykki fyrir nýrri stefnu.',
      reportCount_one: '{{count}} skýrsla',
      reportCount_other: '{{count}} skýrslur',
      occurrenceCount_one: '{{count}} tilvik',
      occurrenceCount_other: '{{count}} tilvik',
      action: 'Lausn',
      actionCreate: 'Stofna nýja stefnu',
      actionExtend: 'Víkka núverandi stefnu',
      actionLink: 'Tengja núverandi stefnu',
      existingPolicy: 'Núverandi stefna',
      wholeNetwork: 'Öll keðjan',
      selectedStores: 'Valdar verslanir',
      affectedStores: 'Verslanir í skýrslunum',
      mode: 'Dreifingarlíkan',
      modeDirect: 'Beint til verslana',
      modeCentral: 'Sala í gegnum miðlæga vörugeymslu',
      effectiveFrom: 'Gildir frá',
      effectiveTo: 'Gildir til (ekki með)',
      reason: 'Nauðsynlegur rökstuðningur',
      reasonHelp: 'Notandi, fyrri staða, ný staða og ástæða varðveitast í rekjanleika.',
      previewTitle: 'Skýrslur til endurmats: {{count}}',
      resolveFailed: 'Ekki tókst að vista stefnu eða endurmeta skýrslur.',
      result:
        'Endurmat lokið: alls {{total}}, tilbúnar {{ready}}, enn lokaðar {{blocked}}, villur {{failed}}.',
      leaveUnresolved: 'Skilja óleyst',
      saveAndRevalidate: 'Vista og endurmeta skýrslur',
      revalidating: 'Vista og endurmeta…',
      retry: 'Halda áfram misheppnuðu endurmati',
      scopeKindNETWORK: 'öll keðjan',
      scopeKindSTORES: 'valdar verslanir',
    },
    missing: {
      title: 'Skýrslur sem vantar',
      daysLate_one: '{{count}} degi of seint',
      daysLate_few: '{{count}} dögum of seint',
      daysLate_many: '{{count}} dögum of seint',
      daysLate_other: '{{count}} dögum of seint',
      hoursLate: '{{count}} klst. of seint',
      shipmentScheduleUnavailable:
        'Sala notar opinbera dagáætlun. Engin sendingaráætlun er skráð og því eru eyður í sendingum ekki búnar til.',
      exportCsv: 'Flytja út CSV',
      activeScope: '{{stores}} virkar verslanir · {{networks}} keðjur',
      dailySchedule: 'Dagleg söluáætlun',
      openImport: 'Opna innflutning',
      openCommonIssue: 'Laga sameiginlegt vandamál',
      upload: 'Hlaða upp skýrslu',
      emptyTitle: 'Engar söluskýrslur vantar',
      emptyBody: 'Allir væntanlegir söludagar á tímabilinu hafa staðfesta skýrslu.',
    },
    missingState: {
      EXPECTED_TODAY: 'Væntanlegt í dag',
      OVERDUE: 'Komið fram yfir',
      IN_PROGRESS: 'Innflutningur í gangi',
    },
    history: {
      title: 'Innflutningssaga',
      open: 'Opna',
      markTestData: 'Merkja sem prófunargögn',
      markTestDataTitle: 'Merkja sögulegan innflutning sem prófunargögn',
      markingTestData: 'Merki…',
      testDataLabel: 'Merki prófunargagna',
      testDataLabelHelp: 'Merkið verður að byrja á „STAGING TEST“.',
      testDataReason: 'Rökstuðningur',
      markerKeepsStatus:
        'Aðgerðin bætir aðeins við óbreytanlegu merki prófunargagna. Sýnd staða: {{displayStatus}}; lénstaða: {{domainStatus}}. Skýrslur, staðreyndir og saga breytast ekki.',
      domainStatus: 'Lénstaða: {{status}}',
      dispositionIncompleteSourceRejected: 'Afgreiðsla: ófullkomnum uppruna hafnað',
      rejectionReason: 'Ástæða: {{reason}}',
      markTestDataFailed: 'Ekki tókst að merkja innflutninginn sem prófunargögn.',
      markTestDataSuccess: 'Innflutningurinn var merktur sem prófunargögn án breytinga á sögu.',
      cancel: 'Hætta við',
      emptyTitle: 'Engin saga',
      emptyBody: 'Engar skýrslur passa við síurnar.',
    },
    recommended: {
      COMPARE_AND_RESOLVE: 'Bera saman og leysa',
      RETRY_OR_REUPLOAD: 'Reyna aftur / skoða',
      FIX_MAPPINGS_AND_REVALIDATE: 'Laga og staðfesta',
    },
    status: {
      QUEUED: 'Í biðröð',
      UPLOADED: 'Hlaðið upp',
      PARSING: 'Lesið',
      PROCESSING: 'Í vinnslu',
      PREVIEW_READY: 'Tilbúið til staðfestingar',
      READY: 'Tilbúið',
      BLOCKED: 'Lokað',
      DUPLICATE: 'Tvítekið',
      DATE_CONFLICT: 'Árekstur',
      CONFLICT: 'Árekstur',
      FAILED: 'Villa',
      CONFIRMED: 'Staðfest',
      COMPLETED: 'Lokið',
      COMPLETED_WITH_ERRORS: 'Lokið með vandamálum',
      REVIEW_REQUIRED: 'Þarfnast yfirferðar',
      CANCELLED: 'Hætt við',
      INCOMPLETE_SOURCE_REJECTED: 'Ófullkomnum uppruna hafnað',
      REVALIDATION_FAILED: 'Endurmat mistókst',
      ROLLED_BACK: 'Afturkallað',
      REJECTED: 'Hafnað',
      SUPERSEDED: 'Leyst af hólmi',
      OVERLAP: 'Skörun — fyrri skýrsla gildir',
      NOT_UPLOADED: 'Skýrsla vantar',
    },
    reason: {
      BULK_IMPORT_PROCESSING_FAILED: 'Vinnsla mistókst',
      SHIPMENT_INVOICE_NUMBER_REQUIRED: 'Reikningsnúmer vantar í sendingarlínuna.',
      SHIPMENT_INVOICE_NUMBER_UNSAFE_NUMERIC:
        'Reikningsnúmerið var vistað í Excel sem óörugg tala og gæti hafa misst tölustafi. Stilltu dálkinn Invoice # sem Text og sláðu upprunalega númerið aftur inn.',
      SHIPMENT_INVOICE_NUMBER_INVALID:
        'Reikningsnúmerið er af óstuddri gerð eða á óstuddu sniði. Stilltu Invoice # sem texta.',
      SHIPMENT_INVOICE_NUMBER_TOO_LONG: 'Reikningsnúmerið er lengra en 128 stafir.',
      DATE_CONFLICT: 'Staðfest skýrsla inniheldur önnur gögn',
      UNKNOWN_STORE: 'Óþekkt verslun',
      AMBIGUOUS_STORE: 'Óljós verslun',
      UNKNOWN_PRODUCT: 'Óþekkt vara',
      AMBIGUOUS_PRODUCT: 'Óljós vara',
      MISSING_PRODUCT_DISTRIBUTION: 'Vörudreifingu vantar',
      DISTRIBUTION_POLICY_MISSING: 'Dreifingarreglu vöru vantar',
      CENTRAL_RECONCILIATION_UNSUPPORTED: 'Miðlæg afstemming er ekki studd',
      BLOCKED: 'Staðfesting er lokuð',
      FAILED: 'Innflutningur mistókst',
      SHIPMENT_MANUAL_RECONCILIATION_REQUIRED:
        'Sending krefst handvirkrar afstemmingar við fyrirliggjandi lagerhreyfingu',
    },
    testData: 'Prófunargögn',
    summary: {
      total: 'Samtals',
      processing: 'Í vinnslu',
      ready: 'Tilbúið',
      blocked: 'Lokað',
      duplicate: 'Tvítekið',
      conflict: 'Árekstrar',
      overlapExistingConfirmed: 'Skörun varðveitt',
      failed: 'Villur',
      confirmed: 'Staðfest',
      cancelled: 'Hætt við',
    },
    uploadDurableBatch: 'Varanlega lotan er vistuð. Opnaðu hana eða fylgstu með skránum hér.',
    upload: {
      type: 'Tegund innflutnings',
      choose: 'Velja XLSX skrár',
      limits: 'Allt að 100 skrár, 10 MB hver og 100 MB í lotu.',
      drop: 'Sleppa XLSX skrám hér eða velja skrár',
      progress:
        '{{processed}} / {{total}} afgreitt · {{accepted}} samþykkt · {{failed}} villur · {{invalid}} ógild · {{ready}} tilbúin · {{inProgress}} í vinnslu · {{cancelled}} afturkölluð',
      technicalId: 'Tæknilegt auðkenni: {{id}}',
      fileList: 'Valdar innflutningsskrár',
      filename: 'Skráarheiti',
      size: 'Stærð',
      detectedType: 'Greind tegund',
      detectedDate: 'Greind dagsetning',
      state: 'Staða',
      actions: 'Aðgerðir',
      afterValidation: 'Eftir staðfestingu',
      retry: 'Reyna aftur',
      remove: 'Fjarlægja',
      uploading: 'Hleð upp…',
      start: 'Hlaða upp {{count}} tilbúnum skrám',
      retryFailed: 'Reyna aftur með villuskrár',
      cancelRemaining: 'Hætta við eftirstöðvar',
    },
    uploadState: {
      CHECKING: 'Athuga',
      READY: 'Tilbúið',
      INVALID: 'Ógilt',
      UPLOADING: 'Hleð upp',
      QUEUED: 'Í biðröð',
      DUPLICATE: 'Tvítekin heimild',
      FAILED: 'Villa',
      CANCELLED: 'Hætt við',
    },
    errors: {
      invalidDate:
        'Sláðu inn gilt dagsetningarbil. Lokadagsetning má ekki vera á undan upphafsdegi.',
      BULK_IMPORT_FILE_COUNT_INVALID: 'Lotan fer yfir 100 skrár.',
      BULK_IMPORT_XLSX_REQUIRED: 'Aðeins XLSX skrár eru leyfðar.',
      BULK_IMPORT_FILE_SIZE_INVALID: 'Skrá verður að vera 1 bæti til 10 MB.',
      BULK_IMPORT_BATCH_SIZE_INVALID: 'Lotan fer yfir 100 MB.',
      DUPLICATE_SELECTED: 'Sama skrá hefur þegar verið valin.',
      BULK_IMPORT_DUPLICATE_SOURCE: 'Þessi heimild er þegar í lotunni.',
      UPLOAD_NETWORK_ERROR: 'Upphleðsla rofnaði. Reyndu þessa skrá aftur.',
      INTERNAL_ERROR:
        'Ekki tókst að vista skrána (kóði: INTERNAL_ERROR). Reyndu aftur; ef villan endurtekur sig skaltu gefa upp tæknilega auðkennið.',
      MASTER_DATA_LOCK_TIMEOUT:
        'Önnur aðgerð er að uppfæra grunngögn. Endurnýjaðu gögnin og reyndu aftur.',
      retryFailed: 'Endurtekning var ekki samþykkt.',
      revalidateFailed: 'Endurstaðfesting mistókst.',
      confirmFailed: 'Ekki tókst að staðfesta tilbúnar skýrslur. Engin skýrsla var þvinguð.',
    },
  },
  shipmentWorkspace: {
    physicalQuantityBasis:
      'Efnislegt magn tekur tillit til samþykktrar ráðstöfunar. Eldri skýrslur án ráðstöfunar halda upprunalegu reikningsmagni; það er ekki sönnun um vöruflutning.',
    sourceInvoiceQuantity: 'Upprunalegt reikningsmagn',
    title: 'Sendingar',
    description: 'Staðfestar raunverulegar sendingar í verslanir eftir sendingardegi.',
    openImports: 'Innflutningur sendinga',
    activeRange: '{{from}} — {{to}}',
    confirmedOnly: 'Aðeins staðfest',
    activeFilters: 'Virkar síur: {{count}}',
    expandFilters: 'Sýna síur',
    collapseFilters: 'Fela síur',
    datePreset: 'Tímabil',
    weekPeriods: 'Vika',
    preset: {
      '7d': '7 dagar',
      '28d': '28 dagar',
      '90d': '90 dagar',
      ytd: 'Frá áramótum',
      current_week: 'Núverandi vika',
      previous_week: 'Fyrri vika',
    },
    isoYear: 'ISO ár',
    isoWeek: 'ISO vika',
    isoWeekOption: 'Vika {{week}} · {{range}}',
    from: 'Frá',
    to: 'Til',
    network: 'Keðja',
    allNetworks: 'Allar keðjur',
    store: 'Verslun',
    allStores: 'Allar verslanir',
    productSearch: 'Leita að vöru',
    product: 'Vara',
    allProducts: 'Allar vörur',
    orientation: 'Stefna',
    storesByProducts: 'Verslanir × vörur',
    productsByStores: 'Vörur × verslanir',
    totalShipped: 'Samtals sent',
    storesCount: 'Verslanir: {{count}}',
    productsCount: 'Vörur: {{count}}',
    factsCount: 'Upprunalínur: {{count}}',
    loadFailed: 'Ekki tókst að hlaða sendingafylki.',
    columns: 'Dálkar',
    resetColumnLayout: 'Endurstilla dálka',
    resetRowOrder: 'Endurstilla röð',
    searchColumns: 'Leita í dálkum',
    showAllColumns: 'Sýna allt',
    hideAllColumns: 'Fela allt',
    allMatrixColumns: 'Allir dálkar',
    visibleColumnsCount: 'Sýnilegir: {{visible}} / {{total}}',
    columnSearchResults: 'Leitarniðurstöður',
    showSearchResults: 'Sýna leitarniðurstöður',
    hideSearchResults: 'Fela leitarniðurstöður',
    noColumnSearchResults: 'Engir dálkar fundust',
    noProductsSelected: 'Engar vörur valdar',
    noStoresSelected: 'Engar verslanir valdar',
    pinColumn: 'Festa dálk',
    matrix: 'Sendingafylki',
    rowLabel: 'Verslun / vara',
    sum: 'SAMTALS',
    empty: 'Engar staðfestar sendingar í verslanir á völdu tímabili.',
    noShipment: 'Engin sending',
    unit: { PIECE: 'stk.', KG: 'kg', TRAY: 'bakki' },
    drillDown: 'Sendingarupplýsingar',
    byDay: 'Eftir degi',
    date: 'Sendingardagur',
    quantity: 'Magn',
    sourceEvidence: 'Óbreytanlegar upprunalínur',
    source: 'Uppruni',
  },
  shipmentImports: {
    approvedRepair: {
      title: 'Heildarviðgerðaráætlun sendingar',
      explanation:
        'Aðeins stjórnandi. Forskoðun les alla lotuna og gildandi grunnskrár; vistun framkvæmir eina atóma viðgerðaráætlun en staðfestir ekki sendinguna.',
      loading: 'Les allar línur og gildandi grunnskrár…',
      drift: 'Lota, leiðir, reglur eða vara breyttust. Ekkert var vistað; útbúðu nýja forskoðun.',
      saved: 'Áætlun vistuð með endurskoðunarslóð',
      scope:
        '80907: PIECE→KG; fjórar leiðir; 80862/80865: MAIN→ELDHUS frá 1. okt.; reglur Prís; tvær reikningsleiðréttingar −528 án efnislegrar hreyfingar. Aðskildar +180 sendingar eru óbreyttar.',
      preview: 'Útbúa nýja forskoðun á allri áætluninni',
      issueResult: 'Vandamál: {{before}} fyrir, {{after}} eftir áætlun.',
      decisions:
        'Leiðir: {{routes}} · breytingar: {{transitions}} · reglur: {{policies}} · efnislegar ákvarðanir: {{physical}} · einingarbreyting: 1',
      remainingNegatives: 'Neikvæðar línur án ákvörðunar: {{count}}.',
      effectZero:
        'Þessi vistun býr til 0 skýrslur, staðreyndir eða hreyfingar; engin staðfesting eða KEEP/REPLACE.',
      noConfirmation:
        'Þetta lagar aðeins vörpun og skráir ákvarðanir. Skörun og aðrar neikvæðar línur geta áfram hindrað staðfestingu.',
      reason: 'Rökstuðningur stjórnanda',
      confirmationHint: 'Sláðu nákvæmlega inn',
      confirmation: 'Staðfesting áætlunar',
      close: 'Loka',
      apply: 'Beita allri viðgerðaráætluninni',
    },
    repairRoute: {
      title: 'Breyta samþykktum alþjóðlegum sendingarleiðum',
      help: 'Úttektarskyggð Repair Plan-aðgerð fyrir Admin. Aðgerðin nær aðeins til SKU 80862 og 80865: lokar nákvæmum opnum MAIN-leiðum og byrjar ELDHUS 2026-10-01. Báðar breytingar eru atómískar; sendingin er ekki staðfest.',
      failed:
        'Ekki tókst að undirbúa eða framkvæma leiðabreytinguna. Engin hlutabreyting var vistuð.',
      saved: 'Leiðabreytingin var vistuð með úttekt og outbox-gögnum; sendingin er enn óstaðfest.',
      loading: 'Athuga núverandi leiðir og útgáfur vöruhúsa…',
      drift:
        'Alþjóðlegar leiðir eða virka ELDHUS-vöruhúsið samsvara ekki samþykktu ástandi. Aðgerðin er ekki tiltæk.',
      revision: 'vænt útgáfa {{revision}}',
      reason: 'Samþykktur rökstuðningur eiganda',
      preview: 'Forskoða atómíska breytingu',
      previewSummary: 'Væntanleg vandamál: {{before}} fyrir breytingu, {{after}} eftir hana.',
      confirmation: 'Nákvæm staðfesting',
      close: 'Loka',
      apply: 'Framkvæma Repair Plan',
      saving: 'Vista…',
    },
    incremental: {
      title: 'Stigvaxandi innflutningur sendinga',
      explanation:
        'Nákvæmar endurtekningar með reikningi eru varðveittar sem frumgögn og sleppt. Aðeins nýjar afhendingar geta myndað færslur og hreyfingar.',
      repeated: 'Endurteknar frumraðir: {{count}}',
      new: 'Nýjar afhendingar: {{count}}',
      decision: 'Þarfnast ákvörðunar: {{count}}',
      blocked:
        'Breyttar eða óljósar raðir þurfa skýra uppgjörsákvörðun; engu verður sjálfkrafa skipt út.',
      confirm: 'Sleppa endurtekningum og bæta aðeins við nýjum sendingum',
      confirmationSummary:
        'Til staðfestingar: {{added}} nýjar línur; slepptar endurtekningar: {{repeated}}; breytt: {{changed}}; samþykktar leiðréttingar: {{corrections}}.',
      recipientCorrection: 'Leiðrétting viðtakanda: {{totals}}',
      warehouseCorrection: 'Leiðrétting vöruhúss: {{totals}}',
      canonicalUnchanged: 'Fyrri staðfesta skýrslan verður ekki leyst af hólmi.',
    },
    physical: {
      stale:
        'Gögn hafa breyst frá samþykki ráðstöfunar. Fyrri útgáfan helst í sögunni; ný forskoðun og samþykki eru nauðsynleg.',
      reapprove: 'Undirbúa nýja útgáfu ráðstöfunar',
      title: 'Ráðstöfun efnislegra hreyfinga',
      help: 'Upprunalegt magn og reikningar haldast óbreytt. Ákvarðanir stýra aðeins framtíðarhreyfingum; vistun staðfestir ekki sendinguna.',
      failed:
        'Aðgerðin mistókst. Athugaðu umfang og núverandi stöðu lotunnar; engin sending var staðfest sjálfkrafa.',
      loading: 'Hleð…',
      saved: 'Ákvarðanir vistaðar með rekjanleika. Sendingin var ekki staðfest sjálfkrafa.',
      noNegative: 'Engar neikvæðar línur til flokkunar.',
      source: 'Uppruni / nettó á reikningi',
      kind: 'Tegund atburðar',
      choose: 'Veldu atburð',
      original: 'Tengd jákvæð lína',
      linkHelp: 'Veldu aðeins staðfesta tengingu. Sama magn sannar ekki tengsl.',
      priorFact: 'Staðfest fact úr fyrri skýrslu (eldri leiðrétting)',
      priorFactHelp:
        'Notaðu aðeins fact-auðkenni sem stjórnandi hefur staðfest. Þetta varðveitir sönnun á skýrslu-/færslustigi en ekki ágiskun um gamla hreyfingu.',
      unlinked:
        'Upprunalegur reikningur óþekktur: aðeins valin neikvæð lína fær enga hreyfingu. Aðrar jákvæðar afhendingar haldast óbreyttar.',
      reason: 'Rökstuðningur ákvörðunar',
      summary: 'Uppruni og efnisleg áhrif',
      movementCount: 'Framtíðarhreyfingar í færslubók: {{count}}',
      unit: 'Eining',
      destinationNet: 'Breyting hjá viðtakendum',
      warehouseNet: 'Breyting í upprunavöruhúsum',
      confirmation: 'Skýr staðfesting umfangs',
      close: 'Loka',
      preview: 'Forskoða áhrif',
      saving: 'VISTA…',
      save: 'Vista ákvarðanir — án þess að staðfesta sendingu',
      CANCEL_BEFORE_DISPATCH: 'Afturkallað fyrir sendingu — engar hreyfingar fyrir tengdu línurnar',
      INVOICE_ONLY_NO_DISPATCH: 'Reikningsvilla án sendingar — upprunaleg lína óþekkt',
      DISPOSAL: 'Fargað hjá viðtakanda — engin móttaka í vöruhús',
      RETURN_TO_STOCK: 'Efnisleg skil — móttaka í upprunavöruhús',
    },
    title: 'Opinberar sendingar',
    description: 'Hlaða upp, sannreyna, staðfesta og afturkalla opinberar sendingarskrár.',
    upload: 'Hlaða upp vinnubók',
    history: 'Innflutningssaga',
    filename: 'Skráarheiti',
    shipmentDates: 'Sendingardagar',
    status: 'Staða',
    uploaded: 'Hlaðið upp',
    destinations: 'Áfangastaðir',
    products: 'Vörur',
    lines: 'Sendingarlínur',
    total: 'Heildarmagn',
    ledger: 'Birgðabók',
    pipeline: 'Dreifikerfi',
    preview: 'Forskoðun og vörpun',
    issues: 'Hindrandi vandamál',
    date: 'Dagsetning',
    destination: 'Áfangastaður',
    destinationType: 'Tegund áfangastaðar',
    product: 'Vara',
    warehouse: 'Upprunavöruhús',
    warehouseRouteMissing: 'Vöruhúsleið vantar',
    warehouseSourceDestinationMatch: 'Uppruna- og móttökavöruhús verða að vera ólík',
    confirm: 'Staðfesta opinbera sendingarskýrslu',
    revalidate: 'Sannreyna vörpun aftur',
    resolveStore: 'Bæta við eða tengja verslun',
    rollback: 'Afturkalla skýrslu',
    rollbackReason: 'Ástæða afturköllunar er nauðsynleg',
    detail: 'Upplýsingar um sendingarskýrslu',
    duplicate: 'Þessi vinnubók er tvítekning af sendingargögnum og er ekki hægt að staðfesta hana.',
    conflict: 'Skörun við staðfesta sendingu þarfnast afstemmingar áður en hægt er að staðfesta.',
    semantics:
      'Jákvæð bein sending eykur birgðir verslunar og minnkar upprunavöruhús. Sending í vöruhús eykur móttökavöruhús og minnkar upprunavöruhús. Miðlæg sending minnkar vöruhús og færir aðeins í dreifikerfi. Neikvæðar miðlægar línur eru stöðvaðar.',
    choose: 'Veldu opinbera .xlsx sendingarvinnubók',
    back: 'Til baka í innflutningssögu',
    download: 'Sækja upprunalega skrá',
    unconfirmedDates: 'Dagsetningar verða opinberar við staðfestingu',
    matchProduct: 'Samsvara vöru',
    canonicalProduct: 'Samþykkt vara',
    matchProductHelp:
      'Samsvörun vistar handvirkt samheiti uppruna. Skýrslan er áfram stöðvuð þar til hún er sannreynd aftur.',
    newProductUnit: 'Eining nýrrar vöru',
    createProduct: 'Stofna nýja vöru',
    matchExistingProduct: 'Samsvara núverandi vöru',
    leaveUnresolved: 'Halda óleystu',
    operationFailed: 'Ekki tókst að framkvæma sendingarinnflutning.',
    failure: {
      SHIPMENT_HEADER_INVALID: 'Sendingaskráin er með ógilda dálkahausa.',
      SHIPMENT_DATE_INVALID: 'Sendingaskráin inniheldur ógilda dagsetningu.',
      SHIPMENT_INVOICE_NUMBER_REQUIRED: 'Reikningsnúmer vantar í sendingarlínu.',
      SHIPMENT_INVOICE_NUMBER_UNSAFE_NUMERIC:
        'Reikningsnúmerið var vistað í Excel sem óörugg tala og gæti hafa misst tölustafi. Stilltu dálkinn Invoice # sem Text og sláðu upprunalega númerið aftur inn.',
      SHIPMENT_INVOICE_NUMBER_INVALID:
        'Reikningsnúmerið er af óstuddri gerð eða á óstuddu sniði. Stilltu dálkinn Invoice # sem Text.',
      SHIPMENT_INVOICE_NUMBER_TOO_LONG: 'Reikningsnúmerið er of langt. Hámarkslengd er 128 stafir.',
      SHIPMENT_QUANTITY_MISSING: 'Magn vantar í sendingarlínu.',
      SHIPMENT_REQUIRED_VALUE_MISSING: 'Nauðsynlegt gildi vantar í sendingaskrána.',
      SHIPMENT_DESTINATION_INVALID: 'Sendingaskráin inniheldur ógildan móttökustað.',
      SHIPMENT_PRODUCT_INVALID: 'Sendingaskráin inniheldur ógilt vörugildi.',
      SHIPMENT_INVALID_NUMERIC_CELL: 'Sendingaskráin inniheldur ógilt magn.',
      SHIPMENT_FORMULA_OR_RICH_CELL:
        'Nauðsynlegir reitir sendingaskrár verða að innihalda gildi, ekki formúlur.',
      SHIPMENT_ZERO_QUANTITY: 'Sendingarlína má ekki hafa magnið núll.',
      SHIPMENT_WORKSHEET_UNEXPECTED: 'Sendingaskráin verður að innihalda eitt Netto-vinnublað.',
      SHIPMENT_LINES_MISSING: 'Sendingaskráin inniheldur engar sendingarlínur.',
      SHIPMENT_MALFORMED_XLSX: 'Ekki var hægt að lesa sendingavinnubókina.',
      SHIPMENT_FILE_SIZE_INVALID: 'Sendingaskráin er tóm eða stærri en leyfilegt er.',
      SHIPMENT_NOT_XLSX: 'Sendingagögnin eru ekki gild XLSX-skrá.',
      SHIPMENT_XLSX_LIMIT_EXCEEDED: 'Sendingavinnubókin fer yfir örugg vinnslumörk.',
      SHIPMENT_UNSAFE_XLSX_CONTENT: 'Sendingavinnubókin inniheldur óstuddt óöruggt efni.',
      SHIPMENT_STAGING_FAILED: 'Ekki tókst að undirbúa sendingargögn til staðfestingar.',
      SHIPMENT_PARSE_FAILED: 'Ekki var hægt að lesa gögn úr sendingaskránni.',
    },
  },
  production: {
    title: 'Framleiðsluáætlun',
    planningOnly: 'Áætlið framleiðslu, skráið raunstaðreyndir og bókið birgðir aðeins við lokun.',
    product: 'Vara',
    date: 'Framleiðsludagur',
    location: 'Staðsetning',
    planningUnit: 'Áætlunareining',
    plannedQuantity: 'Áætlað magn',
    quantity: 'Magn',
    status: 'Staða',
    draft: 'Drög',
    planned: 'Áætlað',
    actions: 'Aðgerðir',
    openOrder: 'Opna',
    loading: 'Hleð framleiðslupöntun…',
    close: 'Loka',
    batchPending: 'Lotunúmer vantar',
    plannedVsActual: 'Áætlað / raunverulegt úttak',
    actualsNoLedger: 'Raunstaðreyndir eru bráðabirgðagögn. Birgðir eru aðeins bókaðar við lokun.',
    actualOutput: 'Raunverulegt úttak',
    actualInputs: 'Rauninntök',
    actual: 'Raunverulegt',
    variance: 'Frávik',
    batch: 'Lota',
    expiry: 'Best fyrir',
    actualMaterial: 'Raunverulegt efni',
    actualQuantity: 'Raunverulegt magn',
    waste: 'Framleiðslutap',
    wasteCategory: 'Flokkur taps',
    stage: 'Stig',
    machine: 'Vél/auðlind',
    stageStartedAt: 'Stig hófst',
    stageEndedAt: 'Stig lauk',
    operationMinutes: 'Aðgerðamínútur',
    people: 'Starfsfólk',
    saveActuals: 'Vista raunupplýsingar',
    timingSummary: 'Liðinn tími: {{elapsed}} mín · aðgerð: {{operation}} mín',
    start: 'Hefja',
    completeReview: 'Ljúka — bóka yfirfarin birgðaáhrif',
    cancel: 'Hætta við',
    reverse: 'Snúa við',
    inventoryEffectsPosted: '{{count}} birgðaáhrif bókuð',
    orderStatus: {
      DRAFT: 'Drög',
      PLANNED: 'Áætlað',
      IN_PROGRESS: 'Í vinnslu',
      COMPLETED: 'Lokið',
      CANCELLED: 'Hætt við',
      REVERSED: 'Snúið við',
    },
    savePlan: 'Vista áætlun',
    saveFailed: 'Ekki tókst að vista áætlun.',
    readOnly: 'Þú hefur aðeins lesaðgang.',
    requirementsPreview: 'Forskoðun krafna',
    finishedOutput: 'Fullunnin vara',
    requirement: 'Krafa',
    kind: 'Tegund',
    rolls: 'Heilar rúllur',
    weeklyRequirements: 'Vikuþarfir',
    previousWeek: 'Fyrri vika',
    currentWeek: 'Núverandi vika',
    nextWeek: 'Næsta vika',
    noPlans: 'Engar áætlanir í valinni viku.',
    selectedProduct: 'valda vöru',
    configurationHint:
      'Til að áætla {{product}} þarf stjórnandi að stilla útgáfustýrða uppskrift og pakkasnið. Tiltæk efni: {{materials}}.',
    configuration: 'Stilling áætlunar',
    configurationWorkspaceHelp:
      'Stilla skal uppskrift, umbúðir, filmu og framleiðslustig í einu kostnaðarvinnusvæði. Skipuleggjandinn helst einfaldur.',
    openMaterials: 'Opna efni',
    openProductConfiguration: 'Stilla vöru',
    readyToPlan: 'TILBÚIÐ TIL ÁÆTLUNAR',
    configurationMissing: 'VANTAR STILLINGAR',
    configurationChecklist: {
      recipe: 'Uppskrift',
      output: 'Afrakstur',
      packaging: 'Pökkun',
      multivac: 'Multivac',
      stages: 'Framleiðslustig',
    },
    noConfiguredStages: 'Engin tímasett framleiðslustig eru stillt.',
    newMaterial: 'Nýtt efni',
    materialCode: 'Efniskóði',
    materialName: 'Heiti efnis',
    rollLengthMetres: 'Rúllulengd (m)',
    stockManaged: 'Birgðastýrt',
    costManaged: 'Kostnaðarstýrt',
    unit: 'Eining',
    createMaterial: 'Bæta við efni',
    recipeVersion: 'Uppskriftarútgáfa',
    referenceOutput: 'Viðmiðsúttak',
    ingredient: 'Innihaldsefni',
    ingredientQuantity: 'Magn innihaldsefnis',
    createRecipe: 'Bæta við uppskrift',
    formatVersion: 'Pakkasnið',
    finishedPerUnit: 'Fullunnið á einingu',
    finishedUnit: 'Eining fullunninnar vöru',
    packsPerUnit: 'Pakkar á einingu',
    packagingMaterial: 'Pökkunarefni',
    packagingQuantity: 'Magn umbúða',
    packsPerCycle: 'Pakkar í hverri lotu',
    pitchMetres: 'Vélarstig (m)',
    lowerFilm: 'Neðri filma',
    upperFilm: 'Efri filma',
    createFormat: 'Bæta við sniði',
    chooseProductFirst: 'veldu fyrst vöru',
    missing: {
      PRODUCTION_FORMAT_REQUIRED:
        'Ekkert virkt pakkasnið er stillt fyrir þessa einingu og dagsetningu.',
      PRODUCTION_RECIPE_REQUIRED: 'Engin virk uppskrift er stillt fyrir þessa vöru og dagsetningu.',
      PRODUCTION_RECIPE_OUTPUT_UNIT_MISMATCH:
        'Úttakseining uppskriftar passar ekki sniðinu. Stilltu skýrt samband.',
      PRODUCTION_FILM_CONFIGURATION_REQUIRED:
        'Filmstilling krefst pakka í hverri lotu og vélarstigs.',
      PRODUCTION_FILM_ROLL_LENGTH_REQUIRED: 'Valin filma þarf stillta rúllulengd.',
      generic: 'Nauðsynlega framleiðslustillingu vantar.',
    },
    requirementKinds: {
      INGREDIENT: 'Innihaldsefni',
      PACKAGING: 'Umbúðir',
      LOWER_FILM: 'Neðri filma',
      UPPER_FILM: 'Efri filma',
    },
  },
  dashboard: {
    title: 'Rekstraryfirlit',
    description: 'Einungis lestur: gagnastaða, sala og birgðaathygli.',
    asOf: 'Staða þann',
    network: 'Verslanakeðja',
    allNetworks: 'Allar keðjur',
    store: 'Verslun',
    allStores: 'Allar verslanir',
    loadFailed: 'Ekki tókst að hlaða rekstraryfirliti.',
    dataStatus: 'Gagnastaða',
    latestSales: 'Síðasta staðfesta sala: {{date}}',
    coverage: '28 daga þekja: {{status}}',
    missingSalesDays: 'Vantar söludaga: {{count}}',
    stockIncomplete: 'Ófullnægjandi birgðagögn: {{count}}',
    stockNotInitialized: 'Birgðir ekki frumstilltar: {{count}}',
    latestSalesImport: 'Síðasti söluinnflutningur: {{date}}',
    latestShipmentImport: 'Síðasti sendingainnflutningur: {{date}}',
    importsActionRequired: 'Innflutningur sem krefst aðgerðar: {{count}}',
    importsMissing: 'Skýrslur sem vantar: {{count}} (Sala {{sales}}, Sendingar {{shipments}})',
    oldestImportProblem: 'Elsta innflutningsvandamál: {{date}}',
    salesSnapshot: 'Söluyfirlit',
    period: 'Tímabil',
    knownQuantity: 'Þekkt magn',
    coverageLabel: 'Þekja',
    activeScope: 'Virkt umfang',
    storesProducts: '{{stores}} verslanir · {{products}} vörur',
    noSalesAccess: 'Söluupplýsingar eru ekki aðgengilegar þessum notanda.',
    stockSummary: 'Yfirlit birgðaathygli',
    lowStock: 'Lágt / endurpöntun: {{count}}',
    stockNotManaged: 'Miðstýrt: {{count}}',
    noStockAccess: 'Birgðaupplýsingar eru ekki aðgengilegar þessum notanda.',
    salesTrend: 'Þróun þekktrar sölu',
    salesTrendDescription:
      'Hvert merki er daglegt þekkt magn. ? er vantar heilan söludag, aldrei núll.',
    stockAttention: 'Birgðaathygli',
    product: 'Vara',
    current: 'Núverandi',
    goal: 'MARKMIÐ',
    difference: 'Mismunur',
    reorder: 'Endurpöntun',
    state: 'Staða',
    notNumeric: 'ÓÞEKKT',
    provisional: 'bráðabirgða',
    noStockAttention: 'Engar beinar verslunarlínur þarfnast athygli.',
    topProducts: 'Helstu vörur eftir þekktri sölu',
    storesCount: '{{count}} verslanir',
    dataIssues: 'Gagnavandamál',
    noDataIssues: 'Engin núverandi gagnavandamál.',
    recentImports: 'Nýleg innflutningsvirkni',
    coverageState: { COMPLETE: 'HEIL', INCOMPLETE_DATA: 'ÓFULLNÆGJANDI GÖGN' },
    periods: {
      LATEST_CONFIRMED_DAY: 'Síðasti staðfesti dagur',
      LAST_7_DAYS: 'Síðustu 7 dagar',
      LAST_28_DAYS: 'Síðustu 28 dagar',
    },
    issues: {
      MISSING_SALES_DAYS: 'Vantar söluskýrsludaga: {{count}}',
      STOCK_INCOMPLETE_DATA: 'Birgðareitir með ófullnægjandi gögnum: {{count}}',
      STOCK_NOT_INITIALIZED: 'Ófrumstilltir birgðareitir: {{count}}',
      IMPORT_REVIEW_REQUIRED: 'Innflutningslotur sem þarfnast yfirferðar: {{count}}',
    },
  },
  operations: {
    title: 'Rekstur',
    previous: 'Fyrri vika',
    current: 'Núverandi vika',
    next: 'Næsta vika',
    loadFailed: 'Ekki tókst að hlaða rekstri.',
    brief: 'Vikuyfirlit',
    briefText:
      'Þessa viku: {{planned}} skipulagt, {{inProgress}} í vinnslu, {{completed}} lokið. Sala vantar: {{missingSalesDays}} daga. Óafgreiddar sendingarákvarðanir: {{shipmentOwnerDecisions}}.',
    production: 'Framleiðsla þessa viku',
    openProduction: 'Opna framleiðslu',
    openWarehouse: 'Opna vöruhús',
    storeOrders: 'Pantanir verslana',
    openStoreOrders: 'Opna pantanir',
    storeOrdersCoverage: '{{confirmed}} / {{expected}} staðfestar verslanir · {{missing}} vantar',
    forecast: 'Spá fyrir næstu viku',
    openForecast: 'Opna spá',
    forecastUnavailable: 'Engin spá hefur verið reiknuð enn.',
    lowConfidence: '{{count}} línur með litlu trausti',
    date: 'Dagsetning',
    product: 'Vara',
    quantity: 'Magn',
    location: 'Staðsetning',
    statusLabel: 'Staða',
    moveDepartment: 'Flytja í deild',
    noOrders: 'Engar framleiðslupantanir þessa viku.',
    requirements: 'Vikuþarfir',
    requirement: 'Þörf',
    kind: 'Tegund',
    rolls: 'Rúllur',
    noRequirements: 'Engar áætlaðar þarfir.',
    attention: 'Þarfnast athygli',
    open: 'Opna',
    noIssues: 'Engin rekstrarvandamál núna.',
    issue: {
      missingSalesCoverage: '{{count}} Sales-skýrsludag vantar.',
      shipmentUnconfirmed: 'Shipment-skýrsla er enn óstaðfest.',
      shipmentProductIdentities: '{{count}} óafgreidd Shipment-vöruauðkennisákvörðun(ir).',
      shipmentWarehouseRoutes: '{{count}} óafgreidd Shipment-leið frá vöruhúsi.',
    },
    status: {
      DRAFT: 'Drög',
      PLANNED: 'Skipulagt',
      IN_PROGRESS: 'Í vinnslu',
      COMPLETED: 'Lokið',
      CANCELLED: 'Hætt við',
      REVERSED: 'Snúið við',
    },
  },
  forecast: {
    title: 'Spá',
    model: 'Líkan {{version}} · Sala til {{through}}',
    noRun: 'Engin spá hefur verið reiknuð enn.',
    noRunEditor: 'Engin spá er tiltæk. Endurreiknaðu úr staðfestri sölu þegar gögn eru tilbúin.',
    horizon: { 7: 'Næstu 7 dagar', 14: 'Næstu 14 dagar', 28: 'Næstu 28 dagar' },
    recalculate: 'Endurreikna spá',
    recalculateFailed: 'Ekki tókst að endurreikna spá.',
    addPromotion: 'Bæta við tilboði',
    editPromotion: 'Breyta tilboði',
    productSearch: 'Leita að vöru',
    product: 'Vara',
    store: 'Verslun',
    network: 'Net',
    all: 'Allt',
    date: 'Dagsetning',
    baseline: 'Grunnspá',
    promotion: 'Tilboð',
    final: 'Lokaspá',
    confidence: 'Traust',
    confidenceValue: { HIGH: 'Mikið', MEDIUM: 'Miðlungs', LOW: 'Lítið', NO_DATA: 'Engin gögn' },
    manual: 'Handvirkt',
    manualOverride: 'Handvirk breyting á spá',
    overrideQuantity: 'Lokamagn ({{unit}})',
    reason: 'Ástæða',
    saveOverride: 'Vista breytingu',
    explain: 'Skýra',
    drivers: 'Forsendur',
    close: 'Loka',
    scope: 'Gildissvið',
    from: 'Frá',
    to: 'Til',
    uplift: 'Handvirk hækkun (%)',
    description: 'Lýsing',
    save: 'Vista',
    promotions: 'Tilboð',
    noPromotions: 'Engin tilboð.',
    noUplift: 'Engin handvirk hækkun',
    noRows: 'Engar spár passa við valdar síur.',
    noData: 'Engin gögn',
    loadFailed: 'Ekki tókst að hlaða spá.',
  },
  costing: {
    recipeImportAction: 'Flytja inn uppskrift',
    recipeImportTitle: 'Flytja uppskrift inn úr skjali',
    recipeImportHelp:
      'Hráefni fyrir {{product}} verða lesin. Fyrirliggjandi efni verða endurnýtt og efni sem vantar stofnuð án verðs.',
    recipeImportChooseFile: 'Veldu DOCX- eða PDF-skrá',
    recipeImportFileTooLarge: 'Skráin er stærri en 8 MB.',
    recipeImportReading: 'Les skjal…',
    recipeImportPreview: 'Lesa og forskoða',
    recipeImportNotReady: 'Gild forskoðun þarf að liggja fyrir.',
    recipeImportOutputRequired: 'Sláðu inn jákvætt lokamagn uppskriftar.',
    recipeImportExistingCount: 'Tengt fyrirliggjandi: {{count}}',
    recipeImportNewCount: 'Ný efni: {{count}}',
    recipeImportMissingPrices:
      'Ný efni verða vistuð án verðs. Útreikningurinn verður ófullgerður þar til kostnaður hefur verið skráður.',
    recipeImportOutputQuantity: 'Lokamagn uppskriftar',
    recipeImportOutputUnit: 'Eining lokamagns',
    recipeImportOutputHelp: 'Skráðu raunverulegt magn fullunninnar vöru úr þessari uppskrift.',
    recipeImportSaving: 'Vista…',
    recipeImportSave: 'Stofna efni og vista uppskrift',
    recipeImportStatus: {
      MATCHED: 'Til staðar',
      NEW: 'Nýtt, án verðs',
      UNIT_CONFLICT: 'Einingarárekstur',
      AMBIGUOUS_MATCH: 'Óljóst',
    },
    recipeImportWarnings: {
      PDF_TEXT_UNAVAILABLE: 'PDF-skráin inniheldur engan læsilegan texta.',
      DOCX_DOCUMENT_XML_MISSING: 'Ekki tókst að lesa uppbyggingu DOCX-skjalsins.',
      NO_RECIPE_INGREDIENTS_DETECTED: 'Engin tafla með hráefnum og magni fannst.',
      UNSUPPORTED_RECIPE_FILE_TYPE: 'Stuðningur er við DOCX og textabyggðar PDF-skrár.',
    },
    title: 'Kostnaðarreiknir vöru',
    subtitle: 'Alhliða staðlað, raunverulegt framleiðslulotukostnað og R&D.',
    mode: 'Hamur',
    standard: 'Staðall',
    actual: 'Raunveruleg lota',
    draft: 'Drög / R&D',
    date: 'Reiknidagur',
    product: 'Vara',
    batch: 'Lokið framleiðslulota',
    select: 'Velja',
    draftName: 'Heiti draga',
    outputQuantity: 'Framleiðslumagn',
    output: 'Framleiðsla',
    unit: 'Eining',
    material: 'Efni',
    temporaryMaterial: 'Tímabundið efni',
    quantity: 'Magn',
    unitCost: 'Einingarkostnaður',
    addMaterial: 'Bæta við efni / umbúðum',
    addAndUse: 'Bæta í grunn og nota',
    useOnlyThisCalculation: 'Nota aðeins í þessari útreikningu',
    materialKind: 'Tegund',
    ingredient: 'Hráefni',
    packaging: 'Umbúðir',
    explicitConsumable: 'Skilgreind rekstrarvara',
    stockManaged: 'Birgðastýrt',
    lowerFilm: 'Neðri filma',
    upperFilm: 'Efri filma',
    labor: 'Vinna',
    machine: 'Vél/auðlind',
    addLine: 'Bæta við kostnaðarþætti',
    removeLine: 'Fjarlægja',
    cancel: 'Hætta við',
    component: 'Kostnaðarþáttur',
    componentType: 'Tegund kostnaðarþáttar',
    total: 'Samtals',
    state: 'Staða',
    summary: 'Hagfræði',
    batchCost: 'Lotukostnaður',
    prices: 'Nettó söluverð',
    pricesHint: 'Aðgreindu verð með kommum',
    targetMargin: 'Markmiðsframlegð (%)',
    targetPrice: 'Nauðsynlegt nettóverð',
    whatIf: 'Hvað-ef kostnaðarbreyting (%)',
    scenarioCost: 'Kostnaður sviðsmyndar',
    sellingPrice: 'Nettó söluverð',
    profit: 'Hagnaður / einingu',
    margin: 'Framlegð',
    markup: 'Álagning',
    batchProfit: 'Lotuhagnaður',
    calculationUnavailable: 'Nauðsynlega stillingu eða kostnaðargögn vantar.',
    notCalculated: 'Ekki reiknað',
    notStarted: 'Ekki hafið',
    materials: 'Hráefni / uppskrift',
    production: 'Framleiðsla',
    materialsDescription: 'Hráefni og uppskriftarinntök fyrir þennan útreikning.',
    productionDescription: 'Skráður eða sviðsmyndaður vinnslutími, vinnu- og vélakostnaður.',
    packagingDescription: 'Umbúðir, neðri filma, efri filma og skilgreind rekstrarvara.',
    sectionNavigation: 'Hlutar kostnaðarútreiknings',
    stage: 'Stig',
    operatingTime: 'Vinnslutími',
    provenance: 'Kostnaðargrunnur',
    noComponents: 'Engir kostnaðarþættir í þessum hluta.',
    noOperationalStages: 'Engin vinnslustig eru tiltæk.',
    addIngredient: 'Bæta við hráefni',
    addPackaging: 'Bæta við umbúðum',
    addStage: 'Bæta við stigi',
    recipeStagesHelp:
      'Valfrjáls tímastillt stig nota gildandi vinnu- og vélagjöld í heildarkostnaði lotu.',
    stageCode: 'Stigakóði',
    minutes: 'Mínútur',
    people: 'Fólk',
    materialsSubtotal: 'Samtals hráefni',
    productionSubtotal: 'Samtals framleiðsla',
    packagingSubtotal: 'Samtals umbúðir',
    draftIdentity: 'Staðbundin R&D sviðsmynd — engum rekstrargögnum er breytt.',
    standardIdentity: 'Leyst staðaluppskrift og gildur kostnaðargrunnur.',
    actualIdentity: 'Staðreyndir lokinnar lotu og sögulegur gildur kostnaðargrunnur.',
    currency: 'Gjaldmiðill',
    costSummary: 'Samantekt lotukostnaðar',
    incompleteCost: 'Þekkt upphæð er sýnd, en einn eða fleiri nauðsynlegir kostnaðarliðir vantar.',
    unitCostCard: 'Einingarkostnaður',
    perUnit: 'Á 1 {{unit}}',
    authoritativeUnitsOnly: 'Aðeins einingar með skýra heimilaða umbreytingu eru sýndar.',
    sellingEconomics: 'Söluverð og framlegð',
    addPrice: 'Bæta við verði',
    priceUnit: 'Nettó ISK á {{unit}}',
    calculatePrice: 'Reikna verð',
    scenarios: 'Sviðsmyndir (hvað-ef)',
    scenariosDescription: 'Aðeins staðbundinn samanburður; sviðsmyndir vista eða bóka ekki gögn.',
    scenario: 'Sviðsmynd',
    baselineScenario: 'SCEN 1 — GRUNNUR',
    whatIfScenario: 'HVAÐ-EF',
    costChange: 'Kostnaðarbreyting: {{percent}}%',
    totalCost: 'Heildareiningarkostnaður',
    batchRevenue: 'Lotutekjur',
    priceComparison: 'Samanburður verðtilboða',
    libraryTitle: 'Kostnaðarsafn vara',
    libraryDescription: 'Varanleg, útgáfustýrð kostnaðarlíkön vara. Vistun bókar ekki birgðir.',
    searchModels: 'Leita að vörum og líkönum',
    department: 'Deild',
    allDepartments: 'Allar deildir',
    productOtherDepartment: 'VARAN TILHEYRIR ANNARRI DEILD',
    favorites: 'Eftirlæti',
    favorite: 'Eftirlæti',
    rnd: 'R&D',
    noSavedVersion: 'Engin vistuð útgáfa',
    noSavedModels: 'Engin vistuð kostnaðarlíkön passa við síurnar.',
    selectSavedModel: 'Veldu vistað líkan til að opna útreikning og sögu.',
    versionHistory: 'Óbreytanleg útgáfusaga',
    immutableSnapshots:
      'Vistaðar útgáfur eru óbreytanleg sönnun; endurútreikningur býr til nýja útgáfu með gildandi kostnaði.',
    reopen: 'Opna aftur',
    recalculate: 'Endurreikna',
    useAsTemplate: 'Nota sem sniðmát',
    copy: 'afrit',
    saveDraft: 'Vista drög',
    saveNewVersion: 'Vista nýja útgáfu',
    newProductModel: 'Kostnaðarlíkan vöru',
    approveStandardCost: 'Samþykkja sem staðalkostnað',
    approvalHelp:
      'Býr skýrt til gildistímaðan staðalkostnað vöru fyrir arðsemi. Bókar ekki birgðir.',
    effectiveFrom: 'Gildir frá',
    reason: 'Ástæða',
    approve: 'Samþykkja',
    costingChecklist: 'Gátlisti kostnaðargerðar',
    versionComparison: 'Nú {{current}} · áður {{previous}}',
    productLibrary: 'Vörur',
    costInputBase: 'Kostnaðargrunnur',
    excludedProducts: 'Útilokaðar',
    excludeFromCosting: 'Útiloka frá kostnaðarreikningi',
    restoreCosting: 'Setja aftur í kostnaðarreikning',
    openProductEditor: 'Opna ritil',
    unassignedDepartment: 'Óúthlutað',
    code: 'Kóði',
    currentCost: 'Núverandi kostnaður',
    costHistory: 'Kostnaðarsaga',
    actions: 'Aðgerðir',
    setCost: 'Setja kostnað',
    setRate: 'Setja gjald',
    rateAmount: 'Gjald',
    saveRate: 'Vista gjald',
    costNotManaged: 'Kostnaður ekki stýrður',
    complete: 'Heilt',
    missingCost: 'Kostnað vantar',
    hour: 'klst.',
    noRates: 'Engin virk gjöld.',
    purchaseAmount: 'Innkaupsupphæð',
    purchaseQuantity: 'Innkaupsmagn',
    derivedUnitCost: 'Nákvæmur einingarkostnaður er reiknaður úr innkaupunum.',
    sourceReference: 'Heimild / tilvísun',
    fxRate: 'Gengi í ISK',
    saveCost: 'Vista kostnað',
    filmRollCostHelp: 'Rúlluverði er deilt með lengd: {{length}}.',
    requiredMetres: 'Þörf: {{metres}}',
    practicalRolls: 'hagnýtar rúllur: {{count}} × {{length}}',
    rollLength: 'Lengd rúllu (m)',
    canonicalConfiguration: 'Framleiðslustillingar',
    canonicalConfigurationHelp:
      'Býr aðeins til nýja útgáfu af núverandi framleiðsluuppskrift eða sniði.',
    recipeLines: 'Uppskriftarlínur',
    saveRecipeVersion: 'Vista uppskriftarútgáfu',
    planningUnit: 'Skipulagningareining',
    packsPerPlanningUnit: 'Pakkningar á skipulagningareiningu',
    packagingLines: 'Pökkunarlínur',
    filmMultivac: 'Filma / Multivac',
    packsPerCycle: 'Pakkningar á hring',
    pitchMetres: 'Skref (metrar)',
    filmConfigurationRequired: 'Filma krefst pakkninga á hring og skrefs.',
    saveFormatVersion: 'Vista sniðútgáfu',
    standardShort: 'STD',
    archive: 'Setja í safn',
    materialsMasterTitle: 'Efni og hráefni',
    materialsMasterDescription: 'Sameiginleg efnisgrunnskrá fyrir uppskriftir, umbúðir og kostnað.',
    searchMaterials: 'Leita eftir kóða eða heiti',
    newMaterial: 'Nýtt efni',
    materialCode: 'Efniskóði',
    materialName: 'Heiti efnis',
    materialCodeHelp: 'Innri / ERP / birgjarkóði, t.d. 51465',
    materialNameHelp: 'Heiti sem notað er í uppskriftum, t.d. Nauta Hakkefni',
    savingMaterial: 'VISTAR...',
    materialCreateSuccess: 'Efni bætt við.',
    materialCreateErrors: {
      duplicateCode: 'Efni með kóðann {{code}} er þegar til.',
      invalidCategoryOrUnit: 'Veldu gilda efnisgerð og einingu.',
      permissionDenied: 'Þú hefur ekki heimild til að bæta við efnum.',
      validationFailed: 'Athugaðu nauðsynlega reiti og gildi.',
      saveFailed: 'Ekki tókst að vista efnið. Reyndu aftur.',
    },
    allMaterials: 'Öll',
    noMaterials: 'Engin efni passa við síuna.',
    usedBy: 'Notað í',
    active: 'Virkt',
    archived: 'Óvirkt',
    yes: 'Já',
    no: 'Nei',
    close: 'Loka',
    save: 'Vista',
    costManaged: 'Taka með í kostnaðarútreikning',
    trackStock: 'Fylgjast með birgðum',
    includeCost: 'Taka með í kostnaðarútreikning',
    materialNoCostHelp:
      'Efni sem er ekki kostnaðarstýrt þarf ekki verð og gerir ekki kostnað ófullkominn fyrr en það er notað sem kostnaðarinntak.',
    rollLengthHelp: 'Lengd einnar rúllu í metrum. Rúlluverð er reiknað á metra.',
    noCostHistory: 'Engin vistuð kostnaðarsaga.',
    loadFailed: 'Ekki tókst að hlaða efnum.',
    materialCategory: {
      RAW_MATERIAL: 'Hráefni',
      ADDITIVE: 'Aukefni',
      PACKAGING: 'Umbúðir',
      FILM: 'Filma',
      UNCLASSIFIED: 'Óflokkað',
    },
    productionCostWorkspace: 'Framleiðslukostnaður',
    productionCostWorkspaceDescription:
      'Heildarhagfræði lotu frá hráefni að framlegð. Hver vistuð útgáfa geymir verðsnapshot.',
    calculator: 'Reiknivél',
    calculationHeader: 'Haus útreiknings',
    calculationHeaderHelp: 'Auðkenni, lotugrunnur og viðskiptasamhengi þessarar útgáfu.',
    standardCalculation: 'Staðlaður',
    researchCalculation: 'R&D',
    finishedProduct: 'Fullunnin vara',
    recipe: 'Uppskrift',
    recipeVersion: 'Uppskrift v{{version}}',
    noActiveRecipe: 'Engin virk uppskrift',
    calculationName: 'Heiti útreiknings',
    newCalculation: 'Nýr útreikningur',
    variant: 'Vöruafbrigði',
    inputBatchKg: 'Inntak lotu (kg)',
    pieceWeightGrams: 'Þyngd stykkis (g)',
    piecesPerCarton: 'Stykki í kassa',
    customerOrNetwork: 'Viðskiptavinur / keðja',
    noSpecificCustomer: 'Enginn tiltekinn viðskiptavinur',
    searchProduct: 'Leita eftir kóða, heiti eða samheiti',
    searchMaterial: 'Leita eftir kóða eða heiti',
    recentlyUsed: 'nýlega notað',
    activeRecipe: 'virk uppskrift',
    openProductCard: 'Opna vöruspjald',
    noCurrentPrice: 'Ekkert núverandi verð',
    historicalPrice: 'Sögulegt verð',
    priceEffectiveOn: 'Verð í gildi {{date}}',
    abpPrice: 'ABP-verð',
    abpPriceEffectiveOn: 'ABP · {{date}}',
    catalogGroup: {
      rawMaterials: 'Staðbundið hráefni',
      additives: 'Íblöndunarefni',
      packaging: 'Umbúðir',
      abp: 'ABP hráefni',
      manual: 'Handvirk færsla',
      networks: 'Keðjur',
      stores: 'Verslanir',
    },
    note: 'Athugasemd',
    additionalSettings: 'Viðbótarstillingar',
    additionalSettingsHelp: 'Valfrjálst heiti, afbrigði, stykkjaþyngd og athugasemd.',
    loadCanonicalRecipe: 'Sækja núverandi samþykkta uppskrift',
    recipeCalculationHelp: 'Skráðu kíló hráefna eða nákvæm prósentuhlutföll.',
    chooseProductOrAddIngredient: 'Veldu vöru eða bættu við fyrsta hráefninu',
    missingCostData: 'Kostnaðargögn vantar',
    customerPrice: 'Verð til viðskiptavinar',
    recipePercent: 'Uppskrift í prósentum',
    recipeKg: 'Uppskrift í kílóum',
    manualEntry: 'Handvirk sviðsmynd',
    manualOverride: 'Handvirk yfirskrift',
    lossAndYield: 'Framleiðslutap og nýting',
    lossAndYieldHelp: 'Tapþrep reiknast í röð og aldrei tvisvar.',
    addLossStage: 'Bæta við tapþrepi',
    lossMode: 'Eining taps',
    lossValue: 'Tap',
    massAfterStage: 'Massi eftir þrep',
    laborOperations: 'Aðgerðir og vinna',
    laborOperationsHelp: 'Starfsmenn × klukkustundir × fullur tímakostnaður.',
    addOperation: 'Bæta við aðgerð',
    operation: 'Aðgerð',
    hours: 'Klukkustundir',
    hourlyLoadedCost: 'Fullur tímakostnaður',
    machinesAndEnergy: 'Vélar og orka',
    machinesAndEnergyHelp: 'Vélatími er aðskilinn frá vinnu.',
    addMachine: 'Bæta við vél',
    hourlyCost: 'Kostnaður á klst.',
    packagingMaterials: 'Umbúðaefni',
    packagingMaterialsHelp: 'Notkun á stykki, kassa eða lotu ásamt efnisrýrnun.',
    calculationBasis: 'Reiknigrunnur',
    consumption: 'Notkun',
    wastePercent: 'Efnisrýrnun (%)',
    perPiece: 'Á stykki',
    perCarton: 'Á kassa',
    perBatch: 'Á lotu',
    explicitOtherCosts: 'Annar sundurliðaður kostnaður',
    explicitOtherCostsHelp: 'Gæði, þrif, geymsla, flutningar, orka og förgun sjást sérstaklega.',
    addExplicitCost: 'Bæta við kostnaði',
    category: 'Flokkur',
    name: 'Heiti',
    rate: 'Taxti',
    otherCategory: {
      QUALITY_CONTROL: 'Gæðaeftirlit',
      CLEANING_SANITATION: 'Þrif og sótthreinsun',
      STORAGE: 'Geymsla',
      INTERNAL_LOGISTICS: 'Innri flutningar',
      ADDITIONAL_ENERGY: 'Viðbótarorka',
      WASTE_DISPOSAL: 'Förgun úrgangs',
    },
    costBasis: {
      PER_BATCH: 'Á lotu',
      PER_KG: 'Á kg',
      PER_HOUR: 'Á klukkustund',
      PER_PALLET: 'Á bretti',
    },
    netPriceHelp: 'Öll söluverð og framlegð eru án virðisaukaskatts.',
    priceUnitLabel: 'Eining söluverðs',
    piece: 'stykki',
    carton: 'kassi',
    distributionCost: 'Dreifingarkostnaður / lota',
    discountPercent: 'Afsláttur (%)',
    finishedMass: 'Massi fullunninnar vöru',
    yield: 'Nýting',
    fullPieces: 'Heil stykki',
    fullCartons: 'Heilir kassar',
    costPerKg: 'Kostnaður / kg',
    costPerPiece: 'Kostnaður / stykki',
    costPerCarton: 'Kostnaður / kassa',
    unsavedChanges: 'Óvistaðar breytingar',
    discardUnsavedChanges: 'Henda óvistuðum breytingum?',
    archiveCalculationConfirm: 'Setja útreikning í geymslu? Óbreytanleg saga helst.',
    savingCalculation: 'VISTA…',
    calculationSaved: 'Útgáfa útreiknings vistuð.',
    calculating: 'Reikna…',
    fixValidationErrors: 'Lagfærðu villur áður en útreikningur er vistaður.',
    missingUsedCosts: '{{count}} notuð kostnaðarliði vantar gildandi verð.',
    completeness: {
      COMPLETE: 'Fullgilt',
      PARTIAL: 'Ófullkomið',
      UNKNOWN_COST: 'Óþekktur kostnaður',
    },
    validation: {
      INPUT_BATCH_MUST_BE_POSITIVE: 'Inntak lotu þarf að vera meira en núll.',
      RECIPE_PERCENT_MUST_EQUAL_100: 'Hlutföll uppskriftar þurfa að vera nákvæmlega 100%.',
      LOSS_PERCENT_EXCEEDS_100: 'Prósentutap má ekki fara yfir 100%.',
      LOSS_EXCEEDS_AVAILABLE_MASS: 'Tap má ekki vera meira en tiltækur massi.',
      PIECE_WEIGHT_MUST_BE_POSITIVE: 'Þyngd stykkis þarf að vera meiri en núll.',
      PACKAGING_CONVERSION_REQUIRED: 'Umbúðir á stykki/kassa krefjast skýrrar umreikningar.',
      SELLING_UNIT_CONVERSION_REQUIRED: 'Valin sölueining krefst skýrrar umreikningar.',
      DISCOUNT_EXCEEDS_100: 'Afsláttur má ekki fara yfir 100%.',
      TARGET_MARGIN_MUST_BE_BELOW_100: 'Markframlegð þarf að vera undir 100%.',
      VALUE_MUST_BE_NON_NEGATIVE: 'Gildi má ekki vera neikvætt.',
    },
    recipePercentTotal: 'Samtala uppskriftar',
    all: 'Allt',
    approved: 'Samþykkt',
    sort: 'Röðun',
    sortUpdated: 'Nýlega breytt',
    sortCalculationDate: 'Dagsetning útreiknings (nýjast)',
    sortName: 'Heiti',
    sortCostAsc: 'Einingarkostnaður hækkandi',
    sortCostDesc: 'Einingarkostnaður lækkandi',
    sortMarginAsc: 'Framlegð hækkandi',
    sortMarginDesc: 'Framlegð lækkandi',
    dateFrom: 'Útreikningsdagur frá',
    dateTo: 'Útreikningsdagur til',
    comparisonDifference: 'Mismunur',
    comparisonDifferencePercent: 'Mismunur %',
    laborTime: 'Vinnutími',
    defaultApprovalReason: 'Samþykkt mynd af framleiðslukostnaði',
    departments: 'deildir',
    calculations: 'útreikningar',
    costBaseTruthHelp:
      'Gildandi efnis-, vinnu- og vélataxtar eru sameiginlegir með Framleiðslu; enginn annar grunnur er búinn til.',
    openMaterials: 'Opna efnisgrunn',
    version: 'Útgáfa',
    compareVersions: 'Bera saman vistaðar útgáfur',
    scenarioA: 'Sviðsmynd A',
    scenarioB: 'Sviðsmynd B',
    metric: 'Mælikvarði',
    restore: 'Endurheimta',
  },
  orders: {
    title: 'Pantanir verslana',
    description: 'Skýrt eftirspurnargagn verslana eftir afhendingarlotu.',
    entry: 'SKRÁ PANTANIR',
    summary: 'YFIRLIT',
    submitted: 'SENDAR PANTANIR',
    newRound: 'Ný afhendingarlota',
    closeRound: 'Loka lotu',
    round: 'Afhendingarlota',
    deliveryDate: 'Afhendingardagur',
    reference: 'Tilvísun',
    expectedStores: 'Væntanlegar verslanir',
    storesInOrder: 'Verslanir í pöntun',
    addStore: 'Bæta við verslun',
    addStoreButton: 'Bæta við',
    addingStore: 'BÆTIR VIÐ...',
    removeStore: 'Fjarlægja verslun',
    removingStore: 'FJARLÆGIR...',
    removeStoreConfirm: 'Fjarlægja {{store}} úr þessari lotu?',
    removeDraftStoreConfirm:
      'Þessi verslun er með vistuð drög. Hætta við drögin og fjarlægja verslunina úr lotunni?',
    cancelDraftAndRemove: 'Hætta við drög og fjarlægja',
    confirmedStoreRemoveBlocked:
      'Þessi verslun er með staðfesta pöntun. Afturkallaðu pöntunina fyrst.',
    removeConfirmedStoreConfirm:
      'Afturkalla staðfesta pöntun fyrir {{store}} og fjarlægja verslunina úr lotunni?',
    cancelConfirmedOrderAndRemove: 'Afturkalla pöntun og fjarlægja verslun',
    confirmedOrderCancelledAndStoreRemoved: 'Pöntun afturkölluð. Verslun fjarlægð úr lotunni.',
    roundUpdateErrors: {
      staleRevision: 'Lotan breyttist. Gögnin voru endurhlaðin — reyndu aftur.',
      invalidStore: 'Ekki er hægt að bæta völdu versluninni við.',
      roundNotEditable: 'Ekki er hægt að breyta lokaðri lotu.',
      activeStoreOrders: 'Ekki er hægt að fjarlægja verslun með virka pöntun úr lotunni.',
      confirmedStoreLocked: 'Þessi verslun er með staðfesta pöntun. Afturkallaðu pöntunina fyrst.',
      addFailed: 'Ekki tókst að bæta versluninni við.',
      removeFailed: 'Ekki tókst að fjarlægja verslunina.',
    },
    searchStore: 'Leita að verslun',
    selectStore: 'Veldu verslun til að skrá pöntun.',
    noRound: 'Engin opin pöntunarlota.',
    noRoundForWeek:
      'Engin pöntunarlota er í þessari viku. Lokaðar sögulegar vikur eru áfram aðgengilegar þegar þær eru valdar.',
    weekHeading: 'VIKA {{week}} · {{from}}–{{to}}',
    previousWeek: 'Fyrri vika',
    currentWeek: 'Núverandi vika',
    nextWeek: 'Næsta vika',
    department: 'Deild',
    allDepartments: 'Allar deildir',
    network: 'Net',
    allNetworks: 'Öll net',
    addProduct: 'Bæta við vöru',
    removeProduct: 'Fjarlægja vöru',
    orderEditor: 'Pöntunarritill',
    quantity: 'Magn',
    note: 'Athugasemd',
    saveDraft: 'Vista drög',
    confirm: 'Staðfesta pöntun',
    confirmedStores: 'Staðfestar verslanir',
    missingStores: 'Verslanir sem vantar',
    product: 'Vara',
    ordered: 'Pantað',
    planned: 'Þegar áætlað',
    remaining: 'Á AÐ GERA',
    statusLabel: 'Staða',
    productionWarehouse: 'Framleiðslugeymsla',
    createProduction: 'Búa til framleiðsludrög',
    ready: 'Tilbúið',
    productionConfigured: 'Framleiðsla stillt',
    pickingRequired: 'Til samsetningar',
    overplanned: 'Ofáætlað',
    resetDepartmentOrder: 'Endurstilla deildaröð',
    resetProductOrder: 'Endurstilla vöruöð',
    storesList: 'Verslunarlisti',
    productMatrix: 'Vörutafla',
    store: 'Verslun',
    version: 'Útgáfa',
    confirmedAt: 'Staðfest',
    show: 'Sýna',
    history: 'Útgáfusaga',
    previous: 'Fyrri verslun',
    next: 'Næsta verslun',
    create: 'Búa til',
    cancel: 'Hætta við',
    loading: 'Hleð…',
    notReceived: 'Ekki móttekið',
    importOrderFile: 'Flytja inn pöntunarskrá',
    fileImportReview: 'Yfirferð skráarinnflutnings',
    pdfTextUnavailable: 'Þessi PDF inniheldur ekki texta fyrir sjálfvirkan innflutning.',
    storeMatches: 'VERSLUN STEMMIR',
    possibleStoreMismatch: 'MÖGULEGT MISRÆMI VERSLUNAR: fann {{store}}.',
    fileImportFailed: 'Ekki tókst að lesa skrána. Þú getur skráð pöntunina handvirkt.',
    selectedStore: 'Valin verslun: {{store}}',
    readFromImage: 'Lesa úr mynd',
    imageReview: 'Yfirferð myndlestrar',
    imageReadFailed: 'Ekki tókst að lesa myndina. Þú getur skráð pöntunina handvirkt.',
    retryImageRead: 'Reyna aftur',
    enterManually: 'Skrá handvirkt',
    reviewRequired: 'Þarf yfirferð',
    addToDraft: 'Bæta við pöntunardrög',
    sources: 'Heimildir',
    removeLine: 'Fjarlægja línu',
    rememberImageAlias: 'Muna samheiti',
    imageState: {
      READY: 'TILBÚIÐ',
      REVIEW: 'YFIRFERÐ',
      UNMATCHED: 'ÓSAMRÆMT',
      INVALID_QUANTITY: 'ÓGILT MAGN',
      UNIT_REVIEW: 'EINING Í YFIRFERÐ',
    },
    status: { NOT_RECEIVED: 'EKKI MÓTTEKIÐ', DRAFT: 'DRÖG', CONFIRMED: 'STAÐFEST' },
  },
  abpCatalog: {
    title: 'ABP vörulisti',
    subtitle:
      'Lesanleg ABP vörugögn, núverandi innkaupsverð og síðasti áreiðanlegi heildarkostnaður.',
    syncNow: 'Samstilla núna',
    lastSync: 'Síðasta heppnaða samstilling: {{date}}',
    neverSynced: 'Aldrei samstillt',
    productCount: '{{count}} vörur',
    syncError:
      'Síðasta samstilling mistókst ({{code}}). Síðasti rétti vörulisti er áfram tiltækur.',
    notConfigured: 'ABP samstilling er ekki stillt. Fyrri skyndiminni er áfram aðeins lesanlegt.',
    manualSyncFailed: 'Handvirk samstilling mistókst. Engum vistuðum vörum var eytt.',
    search: 'Heiti, annað heiti eða PLU',
    freshFrozen: 'Ferskt / frosið',
    all: 'Allt',
    family: 'Vörufjölskylda',
    visibility: 'Sýnileiki',
    priceSource: 'Uppruni verðs',
    dataCompleteness: 'Gögn vantar',
    sort: 'Raða',
    product: 'Vara',
    plu: 'PLU',
    familyVariant: 'Fjölskylda / afbrigði',
    priceEur: 'ABP EUR/kg',
    finalCost: 'Endanlegt ISK/kg',
    dataStatus: 'Gagnastaða',
    details: 'Nánar',
    noResults: 'Engar vörur passa við síurnar.',
    loadFailed: 'Ekki tókst að hlaða ABP vörulistanum.',
    officialName: 'Opinbert heiti',
    abpId: 'ABP auðkenni',
    hsCode: 'HS-kóði',
    importMode: 'Innflutningsaðferð',
    costBasis: 'Kostnaðargrunnur',
    warnings: 'Viðvaranir',
    none: 'Ekkert',
    close: 'Loka',
    sync: {
      current: 'Uppfært',
      stale: 'Úrelt',
      error: 'Samstillingarvilla',
      not_configured: 'Ekki stillt',
      empty: 'Tómt skyndiminni',
      syncing: 'Samstillir',
    },
    source: {
      pricebook: 'Virkur verðlisti',
      invoiceFallback: 'Síðasti reikningur til vara',
      missing: 'Verð vantar',
    },
    status: {
      available: 'Tiltækt',
      unavailable: 'Ótiltækt',
      hidden: 'Falið',
      review: 'Yfirferð',
      complete: 'Fullgilt',
    },
    visibilityOption: { all: 'Allt', active: 'Virkt', hidden: 'Falið', unavailable: 'Ótiltækt' },
    missingOption: {
      any: 'Allt',
      price: 'Verð vantar',
      cost: 'Kostnað vantar',
      none: 'Verð og kostnaður fullgild',
    },
    sortOption: {
      name: 'Heiti',
      plu: 'PLU',
      price_eur: 'EUR verð',
      cost_isk: 'ISK kostnaður',
      updated_at: 'Uppfært',
    },
    direction: { asc: 'Hækkandi', desc: 'Lækkandi' },
    import: { tariff: 'Tollskrá', quota: 'Kvóti', exempt: 'Undanþegið / 0%' },
    review: {
      missing_price: 'verð vantar',
      ambiguous_price_source: 'óljós verðheimild',
      missing_family: 'vörufjölskyldu vantar',
      missing_variant: 'afbrigði vantar',
      missing_fresh_frozen: 'ferskt/frosið vantar',
      missing_hs_code: 'HS-kóða vantar',
      missing_import_mode: 'innflutningsaðferð vantar',
      missing_final_cost: 'endanlegan kostnað vantar',
    },
  },
  profitability: {
    title: 'Arðsemi',
    subtitle: 'Lesanlegt yfirlit um nettósölu úr staðfestum sölugögnum og sögulegum kostnaði.',
    readOnly: 'Aðeins lesanlegt',
    from: 'Frá',
    to: 'Til',
    all: 'Allt',
    product: 'Vara',
    store: 'Verslun',
    network: 'Net',
    products: 'Vörur',
    stores: 'Verslanir',
    networks: 'Net',
    view: 'Sýn',
    sort: 'Raða',
    direction: 'Stefna',
    descending: 'Lækkandi',
    ascending: 'Hækkandi',
    quantity: 'Magn',
    revenue: 'Nettótekjur',
    cost: 'Kostnaður',
    profit: 'Hagnaður',
    margin: 'Framlegð',
    completeness: 'Kostnaðargæði',
    date: 'Dagsetning',
    overTime: 'Arðsemi yfir tíma',
    noRows: 'Engin staðfest sala passar við síurnar.',
    loadFailed: 'Ekki tókst að hlaða arðsemi.',
    costProvenance: 'Uppruni kostnaðar',
    standardOnly:
      'Gildandi staðalkostnaður er notaður. Raunverulegur lotukostnaður er aldrei giskaður án opinbers sölu-til-lotu tengils.',
    costVersionCount_one: '{{count}} staðalkostnaðarútgáfa',
    costVersionCount_other: '{{count}} staðalkostnaðarútgáfur',
    state: { COMPLETE: 'Fullgilt', PARTIAL: 'Að hluta', UNKNOWN_COST: 'Óþekktur kostnaður' },
    basis: {
      STANDARD_EFFECTIVE: 'Gildandi staðalkostnaður',
      NO_AUTHORITATIVE_COST: 'Enginn opinber kostnaður',
    },
  },
} satisfies LocaleResources;
